(() => {
  'use strict';
  const page = document.querySelector('.flat-page');
  if (!page) return;

  // ═══ HELPERS ═══
  const $ = id => document.getElementById(id);
  const esc = window.escHtml || (s => { if (!s && s !== 0) return ''; const d = document.createElement('div'); d.textContent = s; return d.innerHTML; });
  const fmt = n => n >= 1e6 ? (n / 1e6).toFixed(n >= 1e7 ? 1 : 2).replace('.', ',') + ' млн \u20bd' : new Intl.NumberFormat('ru-RU').format(n) + ' \u20bd';
  const fmtFull = n => new Intl.NumberFormat('ru-RU').format(n) + ' ₽';
  // ⛔ РАЗДЕЛИТЕЛЬ — ЗАПЯТАЯ, КАК У СЕРВЕРА (23.08.2026). Сервер печатает в заголовке
  // «60,6 м²» (\BroniDom\Seo\FlatHeadline::area), а здесь до сегодня стоял голый
  // toFixed(1) и выходило «60.6 м²»: одна и та же площадь на одном экране была
  // записана двумя способами. Чинится в ИСТОЧНИКЕ, а не правкой уже нарисованного:
  // черновик подменял точку на запятую регулярным выражением по готовым ячейкам
  // характеристик — это второй проход по DOM ради того, что можно напечатать сразу.
  const fmtArea = a => {
    const n = parseFloat(a);
    if (!isFinite(n)) return '';
    return n % 1 === 0 ? n.toFixed(0) : n.toFixed(1).replace('.', ',');
  };

  // PERF-3 (2026-08-03): зеркало серверного thumbProxyUrl() — одна политика картинок
  // на сервере и в JS. Локальные пути отдаём как есть: прокси намеренно принимает
  // только пути под /img/building_renders/, мелкий ассет он бы растянул и утяжелил.
  // ⛔ 14.08.2026: здесь стояло «/img/building_renders/**» — и звёздочки после слеша
  // читались наивным вырезателем комментариев (`/\/\*[\s\S]*?\*\//`, три теста в
  // гейте) как ОТКРЫТИЕ блочного комментария. Пока в файле не было ни одного `*/`,
  // это ничего не портило; первый же добавленный блочный комментарий закрыл бы эту
  // «пару» и вырезал 630 строк кода из того, что читают тесты — включая загрузчик
  // карт. Ловушка сработала ровно так на первой редакции этого блока.
  const thumbUrl = (src, w) => {
    if (!src || typeof src !== 'string') return src || '';
    if (!/^https?:\/\//i.test(src)) return src;
    return '/img-thumb.php?src=' + encodeURIComponent(src) + '&w=' + (w || 1200);
  };

  /* ──────────────────────────────────────────────────────────────────────────
     СТЕНД: адрес картинки, который на проде остаётся прежним
     (доводка 1 блока 2.1 плана local-stand, 10.09.2026)

     ⛔ ЧТО ЛЕЧИМ. Страница квартиры рисует три картинки НЕ через `thumbUrl()`:
     карточку ЖК в боковике, «похожие квартиры» и генплан квартала. Адрес там
     берётся из базы как есть, а в базе у 37 ЖК в `image_url` лежит АБСОЛЮТНЫЙ
     `https://bronidom.ru/…`. На локальной копии сайта это означает, что браузер
     идёт за картинкой на БОЕВОЙ домен: замер верификатора 10.09 — 8 запросов
     наружу со страницы `/flat.php?id=16019620`, один из них на `bronidom.ru`.
     То есть «локальная копия» подглядывала в прод и накручивала ему запросы.

     ⛔ ПОЧЕМУ ЧЕРЕЗ ФЛАГ, А НЕ ПРОСТО `thumbUrl()`. Здесь, в отличие от
     `flats.js`, поведение прода менять НЕ надо: на проде `https://bronidom.ru/img/…`
     — это наш же файл на нашем же диске, и гнать его через уменьшитель значит
     менять боевой трафик ради стенда. Поэтому калитка одна и та же, что у
     Метрики: `window.BRONIDOM_STAND`, который печатает `app/templates/header.php`
     по `APP_ENV` (см. StandMedia). Второго опознавателя стенда в JS не заводим.

     ⛔ Сравнение строгое (`=== true`): на проде флаг `false`, в любом контексте
     без шаблона — `undefined`, и ни то ни другое ветку не откроет.

     На стенде адрес уходит в `/img-thumb.php`, а тот (StandMedia) боевой домен
     не пускает НИКОГДА: отдаёт свою привезённую копию обложки, если она есть,
     иначе честную заглушку. Наружу не уходит ничего.
     ────────────────────────────────────────────────────────────────────────── */
  const standSrc = (url, w) => (window.BRONIDOM_STAND === true ? thumbUrl(url, w) : url);

  const calcMonthly = window.calcMonthly || ((price, downPct, rate, years) => {
    const p = price * (1 - downPct / 100), mr = rate / 100 / 12, n = years * 12;
    return mr === 0 ? Math.round(p / n) : Math.round(p * (mr * Math.pow(1 + mr, n)) / (Math.pow(1 + mr, n) - 1));
  });

  // B2: BuyAbility color coding
  function buyAbilityClass(monthly) {
    if (monthly <= 30000) return 'buyability-green';
    if (monthly <= 60000) return 'buyability-yellow';
    return 'buyability-red';
  }

  const API = '/flat_api.php';

  // ═══ DATA ═══
  const FLAT = window.__FLAT_DATA;
  if (!FLAT) return; // 404 или данные не переданы

  // ФИДЫ-2.0 бл.2: подписи класса помещения приходят ГОТОВЫМИ из PHP (PropertyKind
  // в flat.php) — здесь их не собирают из FLAT.is_apartment, иначе падежи станут
  // вторым источником истины и разъедутся с сервером. Фолбэк = формы «квартиры»:
  // если объект — апартаменты, а подписи не доехали, хуже плашки «Апартаменты» и
  // юр-сноски (обе SSR) он не сделает, зато страница не сломается.
  const KIND = Object.assign(
    { plural: 'Квартиры', pluralLower: 'квартиры', genitive: 'квартиры', buildingPlural: 'Квартиры' },
    window.__FLAT_KIND || {}
  );

  // ═══ INCREMENT VIEW ═══
  fetch(API + '?action=view', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: FLAT.id }),
  }).catch(() => {});

  // ═══ FAVORITES / HIDDEN (localStorage) ═══
  const FAVS_KEY = 'bronidom_flat_favs';
  const HIDE_KEY = 'bronidom_flat_hidden';

  function getFavs() { try { return JSON.parse(localStorage.getItem(FAVS_KEY)) || []; } catch { return []; } }
  function setFavs(arr) { localStorage.setItem(FAVS_KEY, JSON.stringify(arr)); }
  function isFav(id) { return getFavs().includes(id); }
  function toggleFav(id) {
    const favs = getFavs();
    const idx = favs.indexOf(id);
    if (idx >= 0) favs.splice(idx, 1); else favs.push(id);
    setFavs(favs);
    return idx < 0;
  }

  function getHidden() { try { return JSON.parse(localStorage.getItem(HIDE_KEY)) || []; } catch { return []; } }
  function setHidden(arr) { localStorage.setItem(HIDE_KEY, JSON.stringify(arr)); }
  function hideFlat(id) {
    const h = getHidden();
    if (!h.includes(id)) { h.push(id); setHidden(h); }
  }

  /* ── Числа и словари карточки сделки (23.08.2026) ──────────────────────────
     ⛔ ОБЪЯВЛЕНЫ ЗДЕСЬ, А НЕ РЯДОМ СО СВОИМ КОДОМ, И ЭТО НЕ ВКУСОВЩИНА.
        Функции ниже — объявления (`function`), они всплывают наверх и работают
        из списка вызовов сразу. А `const` не всплывает: до своей строки он лежит
        в «мёртвой зоне», и обращение к нему — не `undefined`, а ОШИБКА.
        Живой случай: константы стояли внизу, рядом с buildDeal, и первый же
        запуск на стенде дал «Cannot access 'CALC_DOWN' before initialization» —
        карточка сделки не собралась ВООБЩЕ, а страница выглядела целой.
        Поймал стенд, не тесты.

     Числа по умолчанию — ТЕ ЖЕ, что у renderInfo и у калькулятора ниже по
     странице. Свои придумывать нельзя: платёж в карточке сделки и платёж
     в калькуляторе разошлись бы, и человек увидел бы два разных ответа
     на один вопрос. */
  const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
  const CALC_DOWN = 20;
  const CALC_RATE = 6;
  const CALC_YEARS = 25;
  // Реестр новостроек наш.дом.рф — ведём в ПОИСК по названию ЖК (см. buildTrust).
  const DOMRF_CATALOG = 'https://xn--80az8a.xn--d1aqf.xn--p1ai/'
    + '%D1%81%D0%B5%D1%80%D0%B2%D0%B8%D1%81%D1%8B/'
    + '%D0%BA%D0%B0%D1%82%D0%B0%D0%BB%D0%BE%D0%B3-%D0%BD%D0%BE%D0%B2%D0%BE%D1%81%D1%82%D1%80%D0%BE%D0%B5%D0%BA/';
  const VS_AREA_WINDOW = 3;      // ± метров к площади, чтобы квартиры были сравнимы
  const VS_MIN_SIMILAR = 3;      // меньше трёх похожих — сравнения нет, блок не рисуем

  // ═══ RENDER ALL ═══
  renderHero();
  renderInfo();
  // ⛔ Карточка сделки строится СРАЗУ ПОСЛЕ старого блока цены и в том же проходе.
  //    Черновик ждал прод-рендер до четырёх секунд (40 попыток по 100 мс) —
  //    здесь ждать нечего: данные лежат в window.__FLAT_DATA.
  //
  // ⛔ И ТОЛЬКО ОНА ОБЁРНУТА В try/catch, И ЭТО НЕ ПЕРЕСТРАХОВКА. Дальше по списку
  //    идут характеристики, ипотека, карта, похожие — ВСЁ остальное содержимое
  //    страницы. Падение внутри карточки сделки унесло бы их с собой, и вместо
  //    «нет одного блока» вышла бы пустая карточка квартиры, а таких страниц
  //    40 846. Сегодня это уже случилось дважды в одну смену: `const` в мёртвой
  //    зоне уронил всю карточку сделки, а помощник положения планки cookie —
  //    65 проверок согласия. Оба раза виноват был НОВЫЙ код, а страдал старый.
  //    Цена страховки — молчаливое отсутствие одного блока; цена её отсутствия —
  //    пустая страница.
  try {
    renderDeal();
  } catch (e) {
    // Карточки сделки нет — старый блок цены остаётся видимым: класс `fcr-on`,
    // который его прячет, вешается ПОСЛЕ успешной сборки. Страница цела.
    // 6.2: если карточку напечатал сервер, класс уже стоит, а его карточка без
    // обработчиков — кнопки мёртвые. Возвращаем прежнее поведение отказа: убираем
    // серверную копию и класс, и работает старый блок цены с живой кнопкой брони.
    const ssrLeft = document.querySelectorAll('#flatRail > [data-ssr]');
    if (ssrLeft.length) {
      ssrLeft.forEach((n) => n.remove());
      document.documentElement.classList.remove('fcr-on');
    }
    //
    // ⛔ ОШИБКУ НЕ ПРОГЛАТЫВАЕМ, А ВЫПУСКАЕМ ОТДЕЛЬНОЙ ЗАДАЧЕЙ. Пойманное
    //    исключение не доходит до window.onerror, то есть до js/error-handler.js:
    //    блок молча пропал бы у всех и никто бы не узнал. Это ровно тот случай,
    //    который в проекте уже ловили под именем «сторож, о смерти которого никто
    //    не узнал». Бросок из setTimeout всплывает как обычная необработанная
    //    ошибка, а порядок рендера при этом не рвётся.
    setTimeout(function () { throw e; }, 0);
  }
  renderActions();
  renderDescription();
  renderSpecs();
  renderMortgage();
  renderMap();
  renderMetros();
  renderSimilar();
  renderSeoLinks();
  renderJkCard();
  renderMiniCalc();
  bindRailSelf();
  renderBottomBar();
  renderBackBar();
  renderPriceHistory();
  // Фаза 5+6: AI-планировка
  if (window.FloorPlanRenderer) {
    // Третьим доводом идёт стендовая калитка картинок: поэтажный план — такой же
    // адрес застройщика, как и всё остальное на этой странице (находка 27,
    // доводка 3). На проде standSrc() возвращает адрес как есть.
    window.FloorPlanRenderer.init($('flatFloorPlan'), FLAT, { standSrc: (u) => standSrc(u, 1200) });
  }
  renderGenplan();

  // ═══ [1] HERO — ГАЛЕРЕЯ КВАРТИРЫ (23.08.2026) ═══
  //
  // ⛔ ПРИКАЗ ВЛАДЕЛЬЦА, дословно: «Сделай так, чтоб вначале была фотка плана,
  //    при нажатии потом 2 — поэтажный, и остальные пусть будут рендеры ЖК.
  //    Все, причём». И вдогонку: «Если на квартире 2 фото нет поэтажного плана —
  //    пусть рендер делает, остальные».
  //
  //    Значит порядок ровно такой:
  //        1.  планировка квартиры
  //        2.  поэтажный план — ЕСЛИ ЕСТЬ, иначе первый рендер ЖК
  //        3+. остальные рендеры ЖК — ВСЕ, а не первые несколько
  //    Пустого места во втором кадре не бывает ни при каком раскладе.
  //
  // ⛔ ЗАМЕР (60 случайных продающихся квартир, 23.08):
  //        планировка есть — 60 из 60
  //        поэтажный план  — 37 из 60 (62 %), то есть каждая третья карточка
  //                          идёт по запасному пути; оба выглядят одинаково
  //        рендеры ЖК      — у 60 из 60; медиана 9, среднее 10,6, максимум 29
  //
  // ⛔ ВЫБОР САМОЙ ПЛАНИРОВКИ НЕ ПЕРЕИЗОБРЕТАЕМ: первым кадром идёт то, что вернул
  //    window.BroniFlatGallery.buildOrder (js/utils.js) — общий SSOT каталога и
  //    карточки ЖК. Он знает про близнецов, композиты Догмы и типовые чертежи.
  //    Здесь мы лишь ДОБАВЛЯЕМ к нему поэтажник и рендеры дома.
  //
  // ⛔ ВЕС. Замер на ЖК «Дюна» (19 рендеров), через наш сжиматель img-thumb.php:
  //        миниатюра 160 px —   3,7 КБ
  //        большой кадр 1200 — 103,5 КБ
  //        оригинал застройщика 255,6 КБ
  //    «Загрузить все рендеры большими» = 19 × 103,5 ≈ 1,9 МБ на карточку, а карточек
  //    40 846. Поэтому большим грузится ТОЛЬКО первый кадр, остальные живут
  //    миниатюрами 160 px, а большой запрашивается в момент переключения, по одному.
  //
  // ⛔ ШТАТНОГО loading="lazy" ЗДЕСЬ НЕ ХВАТИЛО, И ЭТО ЗАМЕР, А НЕ ДОГАДКА: с ним
  //    из 21 миниатюры браузер загрузил 20 при десяти видимых — у него очень щедрый
  //    запас расстояния, и в узкой ленте он выбирает всё сразу. Своя подгрузка
  //    (адрес подставляется при подъезде) дала 13 из 21 и 46,1 КБ.
  //
  // ⛔ РИСУЕТ ЭТО САМА flat.js, В ОДИН ПРОХОД. В черновике галерея была накладкой:
  //    отдельный скрипт ждал прод-рендер и затирал #flatHero своим (`textContent=''`).
  //    В проде такого второго прохода нет и быть не должно — страница обязана
  //    родиться правильной, а не перерисоваться после.
  function renderHero() {
    const el = $('flatHero');
    if (!el) return;

    // 6.1n: выбор ПЛАНИРОВКИ — единый SSOT window.BroniFlatGallery.buildOrder
    // (js/utils.js): { photos:[план(+листы)], typicalFirst, kinds, hasPlan }.
    const gallery = (window.BroniFlatGallery && window.BroniFlatGallery.buildOrder)
      ? window.BroniFlatGallery.buildOrder(FLAT)
      : { photos: [], typicalFirst: false, kinds: [], hasPlan: false };

    // ── Собираем ленту кадров. `addFrame` отсекает дубли по адресу: обложка дома
    //    почти всегда лежит и в общем списке рендеров, а один и тот же кадр дважды
    //    в ленте — это враньё счётчика «3 из 19».
    const list = [];
    const seenUrl = Object.create(null);
    function addFrame(url, kind, cap) {
      if (!url || typeof url !== 'string') return;
      const u = url.trim();
      if (!u || (!/^https?:\/\//i.test(u) && !/^\/img\/building_renders\//.test(u))) return;
      if (seenUrl[u]) return;
      seenUrl[u] = true;
      list.push({ url: u, kind: kind, cap: cap });
    }

    // 1. Планировка квартиры (и вторые листы дуплексов) — как решил buildOrder.
    (gallery.photos || []).forEach((u, i) => {
      addFrame(u, (gallery.kinds || [])[i] === 'plan' ? 'plan' : 'photo',
        i === 0 ? 'Планировка квартиры' : 'Планировка, лист ' + (i + 1));
    });

    // 2. Поэтажный план. Может не быть — тогда строки просто нет, и второе место
    //    естественным образом занимает первый рендер ЖК из шага 3. Пустой
    //    кадр-заглушка не рисуется НИКОГДА: он хуже отсутствующего.
    addFrame(FLAT.floor_scheme_url, 'plan',
      FLAT.floor ? 'Поэтажный план · этаж ' + FLAT.floor : 'Поэтажный план');
    if (!gallery.hasPlan && FLAT.card_render_url) {
      addFrame(FLAT.card_render_url, 'photo', 'Рендер ЖК');
    }

    // 3. ВСЕ рендеры ЖК. Обложка первой — на случай, если её нет в общем списке.
    const jkName = FLAT.building_name || 'жилой комплекс';
    const renders = [];
    if (FLAT.building_image) renders.push(FLAT.building_image);
    (Array.isArray(FLAT.building_photos) ? FLAT.building_photos : []).forEach(u => renders.push(u));
    const beforeRenders = list.length;
    renders.forEach(u => addFrame(u, 'photo', ''));
    // Подписи рендерам проставляем ПОСЛЕ дедупликации — иначе номера «3 из 19»
    // считали бы выброшенные дубли и врали бы человеку.
    const rendersTotal = list.length - beforeRenders;
    for (let i = beforeRenders; i < list.length; i++) {
      list[i].cap = jkName + ' · вид ' + (i - beforeRenders + 1) + ' из ' + rendersTotal;
    }

    const photos = list.map(it => it.url);
    const kinds = list.map(it => it.kind);
    const planCls = i => (kinds[i] === 'plan' ? ' flat-plan-img' : '');
    // Пометка «типовая планировка» когда показан типовой чертёж группы (не своей квартиры).
    const typicalNote = gallery.typicalFirst ? '<span class="flat-hero-typical">типовая планировка</span>' : '';

    // Нет вообще ничего → брендовая заглушка (у части квартир Догмы чертежа в фиде
    // нет, а дом без рендеров бывает у новых фидов). Поэтажник при этом остаётся
    // в своей секции «Поэтажный план» ниже.
    if (!photos.length) {
      el.innerHTML = '<div class="flat-hero-noimg flat-hero-noplan">'
        + '<i class="fa-solid fa-ruler-combined"></i>'
        + '<span>Планировка уточняется у застройщика</span></div>';
      return;
    }

    const alt0 = esc(list[0].cap === 'Рендер ЖК' ? 'Рендер ЖК' : roomsLabel(FLAT.rooms) + ' ' + fmtArea(FLAT.area) + ' м²');

    // Один кадр — галерею рисовать незачем: ни стрелок, ни счётчика, ни ленты.
    if (photos.length === 1) {
      el.innerHTML = '<div class="flat-hero-main">'
        + '<img src="' + esc(thumbUrl(photos[0], 1200)) + '" alt="' + alt0
        + '" class="flat-hero-img' + planCls(0) + '" id="flatHeroImg">' + typicalNote
        + '</div>';
      const only = $('flatHeroImg');
      if (only) only.addEventListener('click', () => openLightbox(photos, 0, { kinds }));
      return;
    }

    const N = photos.length;
    let cur = 0;

    // ── Разметка. Строим УЗЛАМИ, без innerHTML: адреса кадров приходят из фида
    //    застройщика, то есть это чужая строка, и склейка HTML тут была бы дырой.
    const node = (tag, cls, text) => {
      const n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    };
    const fa = (classes) => {
      const i = document.createElement('i');
      i.className = classes;
      i.setAttribute('aria-hidden', 'true');
      return i;
    };

    const main = node('div', 'flat-hero-main flat-gal-main');

    const img = document.createElement('img');
    img.id = 'flatHeroImg';
    img.className = 'flat-hero-img' + planCls(0);
    img.src = thumbUrl(photos[0], 1200);
    img.alt = alt0;
    img.loading = 'eager';           // первый кадр — единственный, что грузится сразу
    img.decoding = 'async';
    main.appendChild(img);
    if (gallery.typicalFirst) {
      main.appendChild(node('span', 'flat-hero-typical', 'типовая планировка'));
    }

    const cap = node('span', 'flat-gal-cap', list[0].cap);
    main.appendChild(cap);

    const counter = node('span', 'flat-gal-count', '1 / ' + N);
    main.appendChild(counter);

    // ⛔ Стрелки — НАСТОЯЩИЕ кнопки, а не div с обработчиком: иначе они не получают
    //    фокус с клавиатуры и не читаются экранным диктором.
    const mkNav = (dir, label, chevron) => {
      const b = node('button', 'flat-gal-nav is-' + dir);
      b.type = 'button';
      b.setAttribute('aria-label', label);
      b.appendChild(fa('fa-solid ' + chevron));
      return b;
    };
    const prev = mkNav('prev', 'Предыдущий кадр', 'fa-chevron-left');
    const next = mkNav('next', 'Следующий кадр', 'fa-chevron-right');
    main.appendChild(prev);
    main.appendChild(next);

    const allBtn = node('button', 'flat-hero-all-btn flat-gal-all');
    allBtn.type = 'button';
    allBtn.id = 'flatAllPhotos';
    allBtn.appendChild(fa('fa-solid fa-images'));
    allBtn.appendChild(document.createTextNode(' Все фото (' + N + ')'));
    main.appendChild(allBtn);

    // ── Лента миниатюр: ВСЕ N штук (не первые шесть, как было до 23.08 — владелец
    //    просил «все, причём»). Кадр запрашивается, только когда миниатюра реально
    //    подъехала к видимой части ленты: см. замер про loading="lazy" в шапке.
    const strip = node('div', 'flat-hero-thumbs flat-gal-thumbs');
    const EAGER = 4;                       // первые четыре — сразу, без мигания
    const thumbs = list.map((it, i) => {
      const t = document.createElement('img');
      t.className = 'flat-hero-thumb' + planCls(i) + (i === 0 ? ' active' : '');
      t.alt = it.cap;
      t.decoding = 'async';
      t.dataset.idx = String(i);
      t.dataset.src = thumbUrl(it.url, 160);
      if (i < EAGER) { t.src = t.dataset.src; delete t.dataset.src; }
      strip.appendChild(t);
      return t;
    });

    // Наблюдатель за подъездом миниатюр. Запас 200 точек по горизонтали — примерно
    // три миниатюры вперёд, чтобы при прокрутке они успевали появиться. Браузер без
    // IntersectionObserver получает всё сразу: лучше лишний вес, чем пустая лента.
    if (typeof IntersectionObserver === 'function') {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const t = e.target;
          if (t.dataset.src) { t.src = t.dataset.src; delete t.dataset.src; }
          io.unobserve(t);
        });
      }, { root: strip, rootMargin: '0px 200px' });
      thumbs.forEach((t) => { if (t.dataset.src) io.observe(t); });
    } else {
      thumbs.forEach((t) => { if (t.dataset.src) { t.src = t.dataset.src; delete t.dataset.src; } });
    }

    function show(i) {
      if (i < 0) i = N - 1;
      if (i >= N) i = 0;
      cur = i;
      const it = list[i];
      img.src = thumbUrl(it.url, 1200);
      img.alt = it.cap || alt0;
      img.classList.toggle('flat-plan-img', it.kind === 'plan');
      cap.textContent = it.cap;
      counter.textContent = (i + 1) + ' / ' + N;
      thumbs.forEach((t, k) => t.classList.toggle('active', k === i));
      // Активная миниатюра сама подъезжает в видимую часть ленты — иначе на 21 кадре
      // стрелками уходишь «в никуда»: кадр меняется, лента стоит.
      const t = thumbs[i];
      // Активной миниатюре кадр нужен наверняка: наблюдатель мог до неё не дойти.
      if (t && t.dataset.src) { t.src = t.dataset.src; delete t.dataset.src; }
      if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    prev.addEventListener('click', (e) => { e.stopPropagation(); show(cur - 1); });
    next.addEventListener('click', (e) => { e.stopPropagation(); show(cur + 1); });
    strip.addEventListener('click', (e) => {
      const t = e.target.closest('.flat-hero-thumb');
      if (t) show(parseInt(t.dataset.idx, 10) || 0);
    });
    const openHere = () => openLightbox(photos, cur, { kinds });
    img.addEventListener('click', openHere);
    allBtn.addEventListener('click', (e) => { e.stopPropagation(); openHere(); });

    // Свайп пальцем по кадру. Порог 40 точек: меньше ловит случайные касания при
    // вертикальной прокрутке, больше требует размашистого жеста.
    // ⛔ Оба слушателя ПАССИВНЫЕ, и `touch-action` мы не трогаем: вертикальный жест
    //    пальцем обязан листать страницу, а не упираться в галерею.
    let sx = 0, sy = 0, moved = false;
    main.addEventListener('touchstart', (e) => {
      const t = e.changedTouches[0];
      sx = t.clientX; sy = t.clientY; moved = false;
    }, { passive: true });
    main.addEventListener('touchend', (e) => {
      const t = e.changedTouches[0];
      const dx = t.clientX - sx, dy = t.clientY - sy;
      // ⛔ Горизонтальность проверяем ДО порога: без этого вертикальная прокрутка
      //    страницы пальцем считалась бы листанием галереи.
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        moved = true;
        show(cur + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
    // Свайп не должен вдобавок открыть лайтбокс: гасим «клик», рождённый жестом.
    main.addEventListener('click', (e) => {
      if (moved) { e.stopPropagation(); moved = false; }
    }, true);

    el.textContent = '';
    el.appendChild(main);
    el.appendChild(strip);
  }

  // ═══ LIGHTBOX ═══
  // jk-redesign 6.5 DRY: реализация вынесена в js/utils.js (window.openLightbox),
  // чтобы каталог (модалка flat-overlay.js) переиспользовал тот же лайтбокс.
  // Вызовы openLightbox(photos, idx) ниже резолвятся в window.openLightbox
  // (utils.js грузится в футере раньше; вызов — по клику, задолго после загрузки).
  //
  // ⛔ СТЕНД (доводка 2 блока 2.1, VERIFY-2.1-3 P1-1 и P2-1). Кадры сюда уходят
  //    СЫРЫМИ: `photos` собран из `FLAT.building_image` и `FLAT.building_photos`
  //    (см. renderHero, :279), а у 37 ЖК в базе там абсолютный
  //    `https://bronidom.ru/…` (находка 24). До этой правки клик по кадру на
  //    локальной копии сайта уводил браузер на БОЕВОЙ домен — замер верификатора:
  //    11 запросов на bronidom.ru с одной страницы квартиры.
  //    Лечим В ОДНОМ месте — в этой обёртке: через неё проходят ВСЕ три вызова
  //    страницы (кадр героя :315, лента :437, генплан :503), и завтрашний
  //    четвёртый пройдёт тоже. Ширина 1200 — как в галерее карточки ЖК
  //    (jk.js:4425), то есть полный кадр, а не миниатюра страницы.
  //    На проде `standSrc()` возвращает адрес КАК ЕСТЬ, и лайтбокс вдобавок
  //    сам не пускает эту функцию без флага стенда (utils.js) — прод дословно прежний.
  //    Свои `opts` вызывающего важнее умолчания, поэтому они идут вторым слоем.
  const openLightbox = (photos, startIdx, opts) => window.openLightbox(
    photos, startIdx, Object.assign({ standSrc: (u) => standSrc(u, 1200) }, opts || {}),
  );

  // ═══ [9b] ГЕНПЛАН КВАРТАЛА с меткой квартиры (Брусника) ═══
  // Рендер квартала сверху: красная метка — эта квартира, белый сектор — куда смотрят окна.
  // Сервер отдаёт готовый URL в FLAT.genplan_url (только там, где кадр есть). Пусто → секция
  // скрыта (не рисуем пустую рамку). Клик открывает генплан в общем лайтбоксе.
  function renderGenplan() {
    const el = $('flatGenplan');
    if (!el) return;
    const url = FLAT.genplan_url || '';
    if (!url) { el.innerHTML = ''; return; }
    let html = '<h2 class="flat-section-title">Где ваша квартира в квартале</h2>';
    html += '<div class="flat-genplan">';
    // ⛔ standSrc() зовётся ПРЯМО В СТРОКЕ, а не через переменную выше: сторож
    // отрисовщиков (tests/Integration/local-stand-isolation.test.mjs) читает
    // исходник, а не исполняет его, и «адрес посчитан двумя строками раньше»
    // отличить от «адрес поставлен как есть» не может. Правило простое: вызов
    // виден в той же строке, где стоит src.
    html += '<img src="' + esc(standSrc(url, 1200)) + '" alt="Генплан квартала с отметкой квартиры" class="flat-genplan-img" '
      + 'loading="lazy" decoding="async" data-ym="flat_genplan_view">';
    html += '<div class="flat-genplan-legend">';
    html += '<span class="flat-genplan-leg-item"><span class="flat-genplan-dot"></span>Ваша квартира</span>';
    html += '<span class="flat-genplan-leg-item"><span class="flat-genplan-cone"></span>Куда смотрят окна</span>';
    html += '</div>';
    html += '</div>';
    el.innerHTML = html;
    const img = el.querySelector('.flat-genplan-img');
    if (img) {
      img.addEventListener('click', () => openLightbox([url], 0, {}));
    }
  }

  // ═══ [2] ОСНОВНАЯ ИНФОРМАЦИЯ ═══
  // ⛔ 6.2 realty-feed-guard (24.09.2026): ЭТОТ БЛОК СЕРВЕР НЕ ПЕЧАТАЕТ — человек его не
  //    видит (класс `fcr-on` прячет его, цена живёт в карточке сделки справа, её сервер
  //    печатает сам, см. renderDeal). А вот СЕТКУ ХАРАКТЕРИСТИК (renderSpecs) и ЦЕНУ НИЖНЕЙ
  //    ПАНЕЛИ сервер печатает, и скрипт затирает их ТЕМ ЖЕ содержимым: правишь разметку или
  //    формат числа там — правь и app/lib/Seo/FlatServerFacts.php + flat_content.php.
  function renderInfo() {
    const el = $('flatInfo');
    if (!el) return;

    // B2: BuyAbility — ежемесячный платёж с color coding
    const monthly = FLAT.price > 0 ? calcMonthly(FLAT.price, 20, 6, 25) : 0;
    const baClass = monthly > 0 ? buyAbilityClass(monthly) : '';
    const buyAbilityHtml = monthly > 0
      ? '<div class="flat-buyability ' + baClass + '">'
      + '  <i class="fa-solid fa-calculator"></i>'
      + '  <span>от ' + esc(new Intl.NumberFormat('ru-RU').format(monthly)) + ' ₽/мес</span>'
      + '  <span class="flat-buyability-note">при 20% взносе, 6%, 25 лет</span>'
      + '</div>'
      : '';

    // C2: Просмотры + "Популярное" badge
    const views = parseInt(FLAT.views, 10) || 0;
    const viewsHtml = '<div class="flat-views-row">'
      + '<span class="flat-views-count"><i class="fa-regular fa-eye"></i> ' + esc(String(views)) + ' просмотров</span>'
      + (views >= 50 ? '<span class="flat-popular-tag"><i class="fa-solid fa-fire"></i> Популярное</span>' : '')
      + '</div>';

    // Скидка: price_old > price
    const priceOld = parseInt(FLAT.price_old, 10) || 0;
    const hasDiscount = priceOld > 0 && priceOld > FLAT.price;
    const discountPct = hasDiscount ? Math.round((priceOld - FLAT.price) / priceOld * 100) : 0;
    const discountAmt = hasDiscount ? (priceOld - FLAT.price) : 0;
    // Срок акции. ⛔ ПОДПИСЬ ПРИХОДИТ ГОТОВОЙ С СЕРВЕРА (FlatHandler::applyDiscountDeadline)
    // и здесь только печатается: часы браузера принадлежат покупателю, и сравнивать
    // по ним дату акции нельзя. Протухшая акция приезжает как null — плашки не будет.
    const discountUntil = String(FLAT.discount_until || '');
    const discountUntilHtml = (hasDiscount && discountUntil)
      ? '<span class="flat-price-discount-until">' + esc(discountUntil) + '</span>'
      : '';
    const priceOldHtml = hasDiscount
      ? '<div class="flat-price-old-row">'
        + '<span class="flat-price-old">' + esc(fmtFull(priceOld)) + '</span>'
        + '<span class="flat-price-discount-badge">−' + discountPct + '% · выгода ' + esc(new Intl.NumberFormat('ru-RU').format(discountAmt)) + ' ₽</span>'
        + discountUntilHtml
        + '</div>'
      : '';
    // Заметная золотая CTA справа от цены (владелец): скролл к форме брони + фокус имени.
    // reserved → «Узнать о похожих» (как нижняя панель). Обычная <button>, клик вешает
    // flat.js по id #flatPriceBook (без inline-handler — CSP). На мобильном 390 плашка
    // переносится под цену на всю ширину (css/flat.css @media).
    const isReserved = String(FLAT.status || '') === 'reserved';
    const bookBtnHtml = '<button type="button" id="flatPriceBook" class="flat-price-book-btn">'
      + '<i class="fa-solid ' + (isReserved ? 'fa-bell' : 'fa-calendar-check') + '"></i> '
      + (isReserved ? 'Узнать о похожих' : 'Забронировать')
      + '</button>';

    el.innerHTML =
      '<div class="flat-price-block' + (hasDiscount ? ' flat-price-block--discount' : '') + '">'
    + '  <div class="flat-price-info">'
    + priceOldHtml
    + '    <div class="flat-price">' + esc(fmtFull(FLAT.price)) + '</div>'
    + '    <div class="flat-price-m2">' + esc(new Intl.NumberFormat('ru-RU').format(FLAT.price_m2)) + ' ₽/м²</div>'
    + buyAbilityHtml
    + '  </div>'
    + bookBtnHtml
    + '</div>'
    + viewsHtml
    + '<div class="flat-main-specs">'
    + '  <div class="flat-main-spec"><span class="flat-spec-val">' + esc(roomsLabel(FLAT.rooms)) + '</span><span class="flat-spec-lbl">Комнаты</span></div>'
    + '  <div class="flat-main-spec"><span class="flat-spec-val">' + esc(fmtArea(FLAT.area)) + ' м²</span><span class="flat-spec-lbl">Площадь</span></div>'
    + '  <div class="flat-main-spec"><span class="flat-spec-val">' + esc(String(FLAT.floor)) + '/' + esc(String(FLAT.floors_total)) + '</span><span class="flat-spec-lbl">Этаж</span></div>'
    + (FLAT.deadline ? '  <div class="flat-main-spec"><span class="flat-spec-val">' + esc(FLAT.deadline) + '</span><span class="flat-spec-lbl">Сдача</span></div>' : '')
    + '</div>';
  }

  // ═══ [A] SHARE-SAVE-HIDE ═══
  function renderActions() {
    const el = $('flatActions');
    if (!el) return;

    const saved = isFav(FLAT.id);

    el.innerHTML =
      '<div class="flat-actions">'
    + '  <button class="flat-action-btn" id="flatShareBtn"><i class="fa-solid fa-arrow-up-from-bracket"></i> Поделиться</button>'
    + '  <button class="flat-action-btn' + (saved ? ' flat-action-active' : '') + '" id="flatSaveBtn"><i class="fa-' + (saved ? 'solid' : 'regular') + ' fa-heart"></i> ' + (saved ? 'Сохранено' : 'Сохранить') + '</button>'
    + '  <button class="flat-action-btn" id="flatHideBtn"><i class="fa-regular fa-eye-slash"></i> Скрыть</button>'
    + '</div>';

    // Share
    const shareBtn = $('flatShareBtn');
    if (shareBtn) {
      shareBtn.addEventListener('click', () => {
        const url = window.location.href;
        const title = document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(() => {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(() => {
            shareBtn.innerHTML = '<i class="fa-solid fa-check"></i> Скопировано';
            setTimeout(() => { shareBtn.innerHTML = '<i class="fa-solid fa-arrow-up-from-bracket"></i> Поделиться'; }, 2000);
          }).catch(() => {});
        }
      });
    }

    // Save
    const saveBtn = $('flatSaveBtn');
    if (saveBtn) {
      saveBtn.addEventListener('click', () => {
        const nowSaved = toggleFav(FLAT.id);
        saveBtn.innerHTML = '<i class="fa-' + (nowSaved ? 'solid' : 'regular') + ' fa-heart"></i> ' + (nowSaved ? 'Сохранено' : 'Сохранить');
        saveBtn.classList.toggle('flat-action-active', nowSaved);
      });
    }

    // Hide
    const hideBtn = $('flatHideBtn');
    if (hideBtn) {
      hideBtn.addEventListener('click', () => {
        hideFlat(FLAT.id);
        hideBtn.innerHTML = '<i class="fa-solid fa-eye-slash"></i> Скрыто';
        hideBtn.classList.add('flat-action-active');
      });
    }
  }

  // ═══ [S6] RAIL «Сделать самому» — избранное / поделиться (6.1j) ═══
  // Реюз логики favorites/share из renderActions; кнопки rail'а привязываются
  // без inline-хендлеров (CSP). «Все квартиры» — обычная ссылка (без JS).
  function bindRailSelf() {
    const favBtn = $('flatRailFav');
    if (favBtn) {
      if (isFav(FLAT.id)) {
        favBtn.classList.add('is-active');
        const i = favBtn.querySelector('i');
        if (i) { i.classList.remove('far'); i.classList.add('fas'); }
      }
      favBtn.addEventListener('click', () => {
        const nowSaved = toggleFav(FLAT.id);
        favBtn.classList.toggle('is-active', nowSaved);
        const i = favBtn.querySelector('i');
        if (i) { i.classList.toggle('fas', nowSaved); i.classList.toggle('far', !nowSaved); }
        // Синхронизация с основной кнопкой «Сохранить» (#flatSaveBtn), если отрисована.
        const mainSave = $('flatSaveBtn');
        if (mainSave) {
          mainSave.classList.toggle('flat-action-active', nowSaved);
          mainSave.innerHTML = '<i class="fa-' + (nowSaved ? 'solid' : 'regular') + ' fa-heart"></i> ' + (nowSaved ? 'Сохранено' : 'Сохранить');
        }
      });
    }

    const shareBtn = $('flatRailShare');
    if (shareBtn) {
      shareBtn.addEventListener('click', () => {
        const url = window.location.href;
        const title = document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(() => {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(() => {
            const span = shareBtn.querySelector('span');
            if (span) {
              const prev = span.textContent;
              span.textContent = 'Скопировано';
              setTimeout(() => { span.textContent = prev; }, 2000);
            }
          }).catch(() => {});
        }
      });
    }
  }

  // ═══ [3] ОПИСАНИЕ ═══
  function renderDescription() {
    const el = $('flatDescription');
    if (!el || !FLAT.description) return;

    el.style.display = '';
    el.innerHTML =
      '<h2 class="flat-section-title">Описание</h2>'
    + '<div class="flat-desc-text flat-desc-clamped" id="flatDescText">' + esc(FLAT.description) + '</div>'
    + '<button class="flat-desc-toggle" id="flatDescToggle">Показать ещё</button>';

    const toggleBtn = $('flatDescToggle');
    const text = $('flatDescText');
    if (toggleBtn && text) {
      toggleBtn.addEventListener('click', () => {
        const clamped = text.classList.toggle('flat-desc-clamped');
        toggleBtn.textContent = clamped ? 'Показать ещё' : 'Свернуть';
      });
    }
  }

  // ═══ [4] ХАРАКТЕРИСТИКИ ═══
  function renderSpecs() {
    const el = $('flatSpecsGrid');
    if (!el) return;

    const specs = [];
    specs.push({ icon: 'fa-ruler-combined', label: 'Площадь общая', value: fmtArea(FLAT.area) + ' м²' });
    if (FLAT.living_area > 0) specs.push({ icon: 'fa-couch', label: 'Жилая площадь', value: fmtArea(FLAT.living_area) + ' м²' });
    if (FLAT.kitchen_area > 0) specs.push({ icon: 'fa-utensils', label: 'Кухня', value: fmtArea(FLAT.kitchen_area) + ' м²' });
    if (FLAT.rooms_area) specs.push({ icon: 'fa-table-cells', label: 'Площади комнат', value: String(FLAT.rooms_area).replace(/(\d)\.(\d)/g, '$1,$2') + ' м²' });
    specs.push({ icon: 'fa-layer-group', label: 'Этаж', value: FLAT.floor + ' из ' + FLAT.floors_total });
    // ⛔ Потолки идут МИМО fmtArea (это не площадь), но разделитель у них тот же:
    //    «2.9 м» рядом с «60,6 м²» — две записи одного и того же на одном экране.
    if (FLAT.ceiling_height > 0) specs.push({ icon: 'fa-arrows-up-down', label: 'Потолки', value: String(FLAT.ceiling_height).replace('.', ',') + ' м' });

    // FEED-030: балконы, санузлы, отделка, вид
    if (FLAT.decoration) specs.push({ icon: 'fa-paint-roller', label: 'Отделка', value: FLAT.decoration });
    // Балкон и лоджия — ОТДЕЛЬНЫМИ строками (владелец 05.07); санузел — словами.
    // Значения приходят строками из PDO ("1"/null) → parseInt для безопасного сравнения.
    // ⚠️ Формат синхронизирован с js/flat-overlay.js buildOverlayChars (модалка каталога).
    // Дрейф между файлами ловит tests/Integration/flat-specs-balcony-loggia.test.mjs.
    const loggias = parseInt(FLAT.loggias, 10) || 0;
    if (loggias > 0) specs.push({ icon: 'fa-door-open', label: 'Лоджия', value: loggias > 1 ? String(loggias) : 'Есть' });
    const balconies = parseInt(FLAT.balconies, 10) || 0;
    if (balconies > 0) specs.push({ icon: 'fa-door-open', label: 'Балкон', value: balconies > 1 ? String(balconies) : 'Есть' });
    const wcSep = parseInt(FLAT.wc_separate, 10) || 0;
    const wcCom = parseInt(FLAT.wc_combined, 10) || 0;
    if (wcSep > 0 || wcCom > 0) {
      const wc = [];
      if (wcSep > 0) wc.push(wcSep > 1 ? wcSep + ' раздельных' : 'Раздельный');
      if (wcCom > 0) wc.push(wcCom > 1 ? wcCom + ' совмещённых' : (wcSep > 0 ? 'совмещённый' : 'Совмещённый'));
      specs.push({ icon: 'fa-bath', label: 'Санузел', value: wc.join(', ') });
    }
    if (FLAT.windows_view) specs.push({ icon: 'fa-mountain-sun', label: 'Вид из окон', value: FLAT.windows_view });

    if (FLAT.section) specs.push({ icon: 'fa-building', label: 'Корпус', value: FLAT.section });
    // ФИДЫ-2.0 блок 4: номер секции/подъезда (CIAN SectionNumber). Это НЕ корпус выше —
    // корпус = литер здания (FLAT.section), секция = подъезд внутри дома (FLAT.section_number).
    if (FLAT.section_number) specs.push({ icon: 'fa-stairs', label: 'Секция', value: FLAT.section_number });
    if (FLAT.number) specs.push({ icon: 'fa-hashtag', label: 'Номер ' + KIND.genitive, value: FLAT.number });
    if (FLAT.building_class) specs.push({ icon: 'fa-gem', label: 'Класс', value: FLAT.building_class });
    if (FLAT.wall_material) specs.push({ icon: 'fa-cubes', label: 'Материал стен', value: FLAT.wall_material });
    if (FLAT.parking_type) specs.push({ icon: 'fa-square-parking', label: 'Парковка', value: FLAT.parking_type });
    specs.push({ icon: 'fa-helmet-safety', label: 'Застройщик', value: FLAT.developer || '—' });
    if (FLAT.cadastral_number) specs.push({ icon: 'fa-file-contract', label: 'Кадастровый номер', value: FLAT.cadastral_number });

    el.innerHTML = specs.map(s =>
      '<div class="flat-spec-item">'
      + '<span class="flat-spec-item-icon"><i class="fas ' + s.icon + '"></i></span>'
      + '<span class="flat-spec-item-label">' + esc(s.label) + '</span>'
      + '<span class="flat-spec-item-value">' + esc(s.value) + '</span>'
      + '</div>'
    ).join('');

    // FEED-030: бейджи (евро, пентхаус, апартаменты)
    const badges = [];
    if (FLAT.is_euro) badges.push('Евро');
    if (FLAT.is_penthouse) badges.push('Пентхаус');
    if (FLAT.is_apartment) badges.push('Апартаменты');
    // ФИДЫ-2.0 блок 4: ипотека (CIAN MortgageAllowed). Бейдж ТОЛЬКО при явном «да» (===1):
    // 0 = фид сказал «нет», null = фид не сказал — в обоих случаях бейдж не рисуем,
    // чтобы не утверждать лишнего (типизация в FlatHandler::getImpl даёт int|null).
    if (FLAT.mortgage_allowed === 1) badges.push('Ипотека');
    if (badges.length) {
      const badgesHtml = badges.map(b => '<span class="flat-badge">' + esc(b) + '</span>').join('');
      el.insertAdjacentHTML('afterend', '<div class="flat-badges">' + badgesHtml + '</div>');
    }
  }

  // ═══ [5] ИПОТЕЧНЫЙ КАЛЬКУЛЯТОР ═══
  function renderMortgage() {
    const el = $('flatMortgageCalc');
    if (!el) return;

    const price = FLAT.price;
    const defaultDown = 20;
    const defaultRate = 6;
    const defaultYears = 25;

    el.innerHTML =
      '<div class="flat-calc-row">'
    + '  <label class="flat-calc-label">Стоимость</label>'
    + '  <input type="text" class="flat-calc-input" id="calcPrice" value="' + new Intl.NumberFormat('ru-RU').format(price) + '" readonly>'
    + '</div>'
    + '<div class="flat-calc-row">'
    + '  <label class="flat-calc-label">Первый взнос, %</label>'
    + '  <input type="range" class="flat-calc-range" id="calcDown" min="10" max="90" value="' + defaultDown + '" step="5">'
    + '  <span class="flat-calc-range-val" id="calcDownVal">' + defaultDown + '%</span>'
    + '</div>'
    + '<div class="flat-calc-row">'
    + '  <label class="flat-calc-label">Ставка, %</label>'
    + '  <input type="range" class="flat-calc-range" id="calcRate" min="0.1" max="30" value="' + defaultRate + '" step="0.1">'
    + '  <span class="flat-calc-range-val" id="calcRateVal">' + defaultRate + '%</span>'
    + '</div>'
    + '<div class="flat-calc-row">'
    + '  <label class="flat-calc-label">Срок, лет</label>'
    + '  <input type="range" class="flat-calc-range" id="calcYears" min="1" max="30" value="' + defaultYears + '" step="1">'
    + '  <span class="flat-calc-range-val" id="calcYearsVal">' + defaultYears + ' лет</span>'
    + '</div>'
    + '<div class="flat-calc-result">'
    + '  <div class="flat-calc-monthly" id="calcMonthly">—</div>'
    + '  <div class="flat-calc-monthly-label">в месяц</div>'
    + '</div>';

    function update() {
      const down = parseInt($('calcDown').value, 10);
      const rate = parseFloat($('calcRate').value);
      const years = parseInt($('calcYears').value, 10);
      $('calcDownVal').textContent = down + '% (' + fmtFull(Math.round(price * down / 100)) + ')';
      $('calcRateVal').textContent = rate.toFixed(1) + '%';
      $('calcYearsVal').textContent = years + ' лет';

      const monthly = calcMonthly(price, down, rate, years);
      $('calcMonthly').textContent = fmtFull(monthly);

      // Mini calc в sidebar
      const mini = $('flatMiniPayment');
      if (mini) mini.textContent = 'от ' + fmt(monthly);
    }

    ['calcDown', 'calcRate', 'calcYears'].forEach(id => {
      const inp = $(id);
      if (inp) inp.addEventListener('input', update);
    });

    update();
  }

  // ═══ [7] КАРТА ═══
  function renderMap() {
    const el = $('flatMap');
    if (!el || !FLAT.latitude || !FLAT.longitude) {
      if (el) el.style.display = 'none';
      return;
    }

    // Lazy init Yandex Maps
    if (typeof ymaps === 'undefined') {
      const mapEl = el;
      mapEl.innerHTML = '<div class="flat-map-placeholder" id="flatMapPlaceholder">Нажмите для загрузки карты</div>';
      mapEl.addEventListener('click', () => {
        const script = document.createElement('script');
        // Ключ едет из PHP через window.YMAPS_KEY (flat.php, тот же inline-script с
        // nonce, что и __FLAT_DATA) — паритет с jk.js:137. Хардкодить его в публичном
        // JS нельзя (Security Hotfix 2 2026-04-23), а пустой apikey здесь и стоял до
        // 30.07.2026: карта грузилась анонимно и держалась только на снисходительности
        // квоты Яндекса.
        script.src = 'https://api-maps.yandex.ru/2.1/?apikey=' + encodeURIComponent(window.YMAPS_KEY || '') + '&lang=ru_RU';
        script.onload = () => ymaps.ready(() => initMap(el));
        document.head.appendChild(script);
      }, { once: true });
      return;
    }

    ymaps.ready(() => initMap(el));
  }

  function initMap(el) {
    el.innerHTML = '';
    const map = new ymaps.Map(el, {
      center: [parseFloat(FLAT.latitude), parseFloat(FLAT.longitude)],
      zoom: 16,
      controls: ['zoomControl'],
    });
    map.geoObjects.add(new ymaps.Placemark(
      [parseFloat(FLAT.latitude), parseFloat(FLAT.longitude)],
      { balloonContent: esc(FLAT.building_name || '') },
      { preset: 'islands#goldDotIcon' }
    ));
  }

  // ═══ METROS ═══
  function renderMetros() {
    const el = $('flatMetros');
    if (!el || !FLAT.metros || !FLAT.metros.length) return;

    const icons = { metro: 'fa-subway', train: 'fa-train', bus_stop: 'fa-bus', highway: 'fa-road' };
    el.innerHTML = FLAT.metros.map(m =>
      '<div class="flat-metro-item">'
    + '  <i class="fa-solid ' + (icons[m.type] || 'fa-location-dot') + '"></i>'
    + '  <span class="flat-metro-name">' + esc(m.name) + '</span>'
    + '  <span class="flat-metro-dist">' + parseFloat(m.distance_km).toFixed(1) + ' км</span>'
    + '</div>'
    ).join('');
  }

  // ═══ [8] ПОХОЖИЕ КВАРТИРЫ ═══
  async function renderSimilar() {
    const el = $('flatSimilarGrid');
    if (!el) return;

    try {
      const res = await fetch(API + '?action=similar&id=' + FLAT.id + '&limit=6');
      const data = await res.json();
      if (!data.ok || !data.flats || !data.flats.length) {
        $('flatSimilar').style.display = 'none';
        return;
      }

      el.innerHTML = data.flats.map(f => {
        const img = f.layout_url || ''; // 28.09.2026: без фото дома в месте планировки
        return '<a href="/flat.php?id=' + esc(String(f.id)) + '" class="flat-similar-card">'
          + (img ? '<img src="' + esc(standSrc(img, 320)) + '" alt="" class="flat-similar-img" loading="lazy">' : '<div class="flat-similar-noimg"><i class="fa-solid fa-building"></i></div>')
          + '<div class="flat-similar-body">'
          + '  <div class="flat-similar-price">' + esc(fmtFull(parseInt(f.price, 10))) + '</div>'
          + '  <div class="flat-similar-specs">' + esc(roomsLabel(f.rooms)) + ' · ' + esc(fmtArea(f.area)) + ' м²</div>'
          + '  <div class="flat-similar-jk">' + esc(f.building_name || '') + '</div>'
          + '</div></a>';
      }).join('');
    } catch (e) {
      $('flatSimilar').style.display = 'none';
    }
  }

  // ═══ [9] SEO-ССЫЛКИ ═══
  function renderSeoLinks() {
    const el = $('flatSeoLinks');
    if (!el) return;

    const links = [];
    const city = encodeURIComponent(FLAT.city || 'krasnodar');
    // Адрес витрины квартир города — ЗЕРКАЛО серверного `CityFlatsUrl::forCity()`
    // (14.08.2026).
    //
    // ⛔ Ровно один способ собрать этот адрес в модуле. Блок СЕО-ссылок целиком рисует
    // этот скрипт, то есть серверная правка адреса до робота бы не доехала: Яндекс
    // исполняет JS и увидел бы старый `flats.php?city=`, то есть 301 на каждой из
    // четырёх ссылок. Ровно так уже ломался блок F.4 на карточке ЖК.
    const cityFlatsPath = '/novostroyki/' + city + '/kvartiry/';
    // ⛔ Фильтры остаются QUERY-строкой поверх ЧПУ. Сервер её не видит (в nginx-rewrite
    // стоит хвостовой `?`) и печатает canonical голой витрины, а js/flats.js читает
    // location.search и применяет фильтр — то есть ссылка работает, а нового
    // индексируемого адреса не порождает. Тот же приём, что у квартир ЖК.
    links.push({ text: roomsLabel(FLAT.rooms) + ' квартиры в ' + (FLAT.city_name || ''), href: cityFlatsPath + '?rooms=' + FLAT.rooms });
    // Ссылка ведёт в список ВСЕГО дома ⇒ подписана по составу ЖК (KIND.buildingPlural),
    // а не по классу открытого объекта. Остальные ссылки блока — общегородские
    // («Все квартиры в Москве»): для каталога целиком «квартиры» верно, их не трогаем.
    if (FLAT.building_id) links.push({ text: KIND.buildingPlural + ' в ' + (FLAT.building_name || 'ЖК'), href: '/flats.php?city=' + city + '&building_id=' + FLAT.building_id });
    if (FLAT.developer) links.push({ text: 'Новостройки ' + FLAT.developer, href: cityFlatsPath + '?developer=' + encodeURIComponent(FLAT.developer) });
    links.push({ text: 'Все квартиры в ' + (FLAT.city_name || ''), href: cityFlatsPath });

    el.innerHTML = '<div class="flat-seo-links-inner">'
      + links.map(l => '<a href="' + esc(l.href) + '" class="flat-seo-link">' + esc(l.text) + '</a>').join('')
      + '</div>';
  }

  // ═══ [S1] SIDEBAR: КАРТОЧКА ЖК ═══
  function renderJkCard() {
    const el = $('flatJkCard');
    if (!el) return;

    const img = FLAT.building_image || '';
    el.innerHTML =
      (img ? '<img src="' + esc(standSrc(img, 320)) + '" alt="' + esc(FLAT.building_name || '') + '" class="flat-jk-thumb" loading="lazy">' : '')
    + '<div class="flat-jk-info">'
    + '  <div class="flat-jk-name">' + esc(FLAT.building_name || '') + '</div>'
    + '  <div class="flat-jk-address">' + esc(FLAT.address || '') + '</div>'
    + '  <div class="flat-jk-dev">' + esc(FLAT.developer || '') + '</div>'
    + '  <a href="' + esc(jkHref({ id: FLAT.building_id, url: FLAT.building_url })) + '" class="flat-jk-link">Перейти к ЖК <i class="fa-solid fa-arrow-right"></i></a>'
    + '</div>';
  }

  // ═══ [S2] MINI CALC ═══
  function renderMiniCalc() {
    const el = $('flatMiniPayment');
    if (!el) return;
    const monthly = calcMonthly(FLAT.price, 20, 6, 25);
    el.textContent = 'от ' + fmt(monthly);
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     КАРТОЧКА СДЕЛКИ, НАДЁЖНОСТЬ, РАЗБОР ПЛОЩАДИ И СРАВНЕНИЕ (23.08.2026)

     Перенос принятого черновика `tools/.hero-draft/flat-card-2026-08-23.js`.
     Точка возврата — `.hero-draft-backup/KARTOCHKA-KVARTIRY_2026-08-23_2320/`.

     ⛔ ЧЕМ ЭТО ОТЛИЧАЕТСЯ ОТ ЧЕРНОВИКА, И ПОЧЕМУ ТАК И НАДО.
        Черновик был НАКЛАДКОЙ: отдельный скрипт зеркала ждал, пока прод дорисует
        страницу (до 40 попыток по 100 мс), и правил уже отрисованный ДОМ снаружи.
        Здесь всё живёт внутри самой flat.js и рисуется ОДИН раз, в общем порядке
        рендера. Ждать нечего и некого: данные лежат в window.__FLAT_DATA, который
        сервер печатает выше по странице.

     ⛔ КЛАСС-ВКЛЮЧАТЕЛЬ `fcr-on` НА <html> — НЕ КОСТЫЛЬ, А ПРЕДОХРАНИТЕЛЬ.
        Под ним стоит единственное опасное правило: `#flatInfo { display: none }`
        (старый блок цены переехал в карточку сделки справа). Ставить его безусловно
        нельзя: не отработал скрипт — и страница осталась бы вообще без цены.
        Класс вешается ПОСЛЕ того, как карточка сделки собрана и вставлена.

     ⛔ СТАРЫЙ БЛОК ЦЕНЫ (#flatInfo) ПРОДОЛЖАЕТ РИСОВАТЬСЯ И ПРЯЧЕТСЯ CSS.
        Это осознанная уступка, а не забывчивость: на нём висит кнопка
        #flatPriceBook, чьё поведение пришпилено tests/JS/flat-booking-cta.test.js
        (две точки входа в форму брони). Снести рендер — уронить проверку, которая
        сторожит не вид, а маршрут. Долг записан в рапорт блока.
     ═══════════════════════════════════════════════════════════════════════════ */

  /** Короткий помощник вместо строковой склейки HTML: без innerHTML — без XSS. */
  function nEl(tag, cls, text) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function nIcon(faClasses) {
    const i = document.createElement('i');
    i.className = faClasses;
    i.setAttribute('aria-hidden', 'true');
    return i;
  }

  /** Склонение по-русски: 1 просмотр · 2 просмотра · 5 просмотров.
      ⛔ 11-14 — исключение: «11 просмотров», а не «11 просмотр». */
  function plural(n, one, few, many) {
    const a = Math.abs(n) % 100;
    if (a > 10 && a < 20) return many;
    const b = a % 10;
    if (b === 1) return one;
    if (b >= 2 && b <= 4) return few;
    return many;
  }

  /** «Цена актуальна на 23 августа» / «…сегодня».
      ⛔ У ПРОДАННОЙ квартиры слово «актуальна» — неправда: лот снят с продажи.
         Там та же дата, но с честной подписью «когда сняли с продажи». */
  function freshText(sold) {
    const raw = String(FLAT.last_seen_at || '').trim();
    if (!raw) return '';
    // «2026-08-23 13:45:11» → разбираем руками: `new Date(строка)` на Safari
    // возвращает Invalid Date именно на пробеле вместо «T».
    const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return '';
    const y = +m[1], mo = +m[2] - 1, d = +m[3];
    if (sold) return 'Цена на ' + d + ' ' + MONTHS[mo] + ', когда лот сняли с продажи';
    const now = new Date();
    if (now.getFullYear() === y && now.getMonth() === mo && now.getDate() === d) {
      return 'Цена актуальна на сегодня';
    }
    return 'Цена актуальна на ' + d + ' ' + MONTHS[mo];
  }

  /** Плавное появление блока при подходе к нему.
      ⛔ Класс fcr-reveal вешаем СКРИПТОМ. Если бы «прозрачность 0» стояла в готовой
         разметке, при выключенном скрипте блок остался бы невидимым навсегда — а он
         собирается тем же скриптом, значит без него его нет вовсе, и прятать нечего. */
  function reveal(node) {
    if (typeof IntersectionObserver !== 'function') return;
    node.classList.add('fcr-reveal');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    obs.observe(node);
  }

  /* ═══ КАРТОЧКА СДЕЛКИ ═══
     Цена · ₽/м² · платёж · калькулятор · метки · кнопка · короткая форма номера ·
     телефон · просмотры. Кладётся ПЕРВОЙ в правую колонку — так у 4 из 5
     разобранных конкурентов (ЦИАН, Яндекс, ДомКлик, Квадрум). */
  function buildDeal() {
    const card = nEl('div', 'fcr-deal');
    card.id = 'fcrDeal';
    // Плашку «Продана» рисует сервер — она и есть признак снятого лота.
    const sold = document.querySelector('.flat-sold-banner') !== null;
    const reserved = String(FLAT.status || '') === 'reserved';

    // ── строка «дата актуальности + сердечко + поделиться» ──
    const top = nEl('div', 'fcr-deal-top');
    const fresh = nEl('span', 'fcr-fresh');
    const ft = freshText(sold);
    if (ft) { fresh.appendChild(nIcon('fa-solid fa-clock')); fresh.appendChild(document.createTextNode(' ' + ft)); }
    top.appendChild(fresh);

    const icons = nEl('div', 'fcr-deal-icons');
    // Сердечко в первом экране — 5 из 5 конкурентов.
    const fav = nEl('button', 'fcr-icon-btn');
    fav.type = 'button';
    fav.id = 'fcrFav';
    fav.setAttribute('aria-label', 'В избранное');
    fav.appendChild(nIcon('far fa-heart'));
    const share = nEl('button', 'fcr-icon-btn');
    share.type = 'button';
    share.id = 'fcrShare';
    share.setAttribute('aria-label', 'Поделиться');
    share.appendChild(nIcon('fas fa-share-nodes'));
    icons.appendChild(fav);
    icons.appendChild(share);
    top.appendChild(icons);
    card.appendChild(top);

    // ── старая цена и выгода (если фид отдал price_old) ──
    const priceOld = parseInt(FLAT.price_old, 10) || 0;
    if (priceOld > 0 && priceOld > FLAT.price) {
      const row = nEl('div', 'fcr-old-row');
      row.appendChild(nEl('span', 'fcr-old', fmtFull(priceOld)));
      const pct = Math.round((priceOld - FLAT.price) / priceOld * 100);
      row.appendChild(nEl('span', 'fcr-badge-off',
        '−' + pct + '% · выгода ' + fmtFull(priceOld - FLAT.price)));
      // Срок акции — готовая подпись с сервера (см. комментарий у главного блока цены).
      const until = String(FLAT.discount_until || '');
      if (until) {
        row.appendChild(nEl('span', 'fcr-until', until));
      }
      card.appendChild(row);
    }

    // ── цена и цена за метр ──
    card.appendChild(nEl('div', 'fcr-price', fmtFull(FLAT.price)));
    if (FLAT.price_m2) {
      card.appendChild(nEl('div', 'fcr-m2',
        new Intl.NumberFormat('ru-RU').format(FLAT.price_m2) + ' ₽/м²'));
    }

    // ── платёж по ипотеке (как «В ипотеку от … /мес.» у Новострой-М) ──
    // ⛔ Считаем ОБЩИМ calcMonthly, тем же, что у renderInfo и у калькулятора ниже
    //    по странице: два способа посчитать одно число всегда расходятся.
    if (FLAT.price > 0) {
      const monthly = calcMonthly(FLAT.price, CALC_DOWN, CALC_RATE, CALC_YEARS);
      if (monthly > 0) {
        const mrow = nEl('div', 'fcr-mortgage');
        mrow.appendChild(nIcon('fa-solid fa-money-bill-wave'));
        // ⛔ Без хвостового пробела: `.fcr-mortgage` — флекс с зазором 8 px, и текстовый
        //    узел становится отдельным элементом ряда. Пробел внутри него складывался
        //    с зазором и давал видимую двойную щель перед числом.
        mrow.appendChild(document.createTextNode('В ипотеку от'));
        // ⛔ Отдельный класс, а не style="…": вид задаёт CSS. Общее правило
        //    `.fcr-mortgage span` красит подписи серым и мелким, а это само число —
        //    оно должно остаться крупным и белым.
        const mval = nEl('span', 'fcr-mortgage-val',
          new Intl.NumberFormat('ru-RU').format(monthly) + ' ₽/мес');
        mval.id = 'fcrMortgageVal';
        mrow.appendChild(mval);
        const mhint = nEl('span', null, CALC_DOWN + '% взнос · ' + CALC_RATE + '% · ' + CALC_YEARS + ' лет');
        mhint.id = 'fcrMortgageHint';
        mrow.appendChild(mhint);
        card.appendChild(mrow);
      }
    }

    // ── живой калькулятор (раскрывается по нажатию) ──
    if (!sold && FLAT.price > 0) card.appendChild(buildCalc());

    // ── метки: комнатность · площадь · этаж · сдача · отделка ──
    const chips = nEl('ul', 'fcr-chips');
    const chipVals = [roomsLabel(FLAT.rooms), fmtArea(FLAT.area) + ' м²'];
    if (FLAT.floor && FLAT.floors_total) chipVals.push(FLAT.floor + ' / ' + FLAT.floors_total + ' этаж');
    if (FLAT.deadline) chipVals.push(window.BuildStatus.deadlineLine(FLAT.deadline));
    if (FLAT.decoration) chipVals.push(String(FLAT.decoration));
    chipVals.forEach((v) => chips.appendChild(nEl('li', null, v)));
    card.appendChild(chips);

    // ── кнопка действия (5 из 5 конкурентов держат её в первом экране) ──
    const cta = nEl('button', 'fcr-cta');
    cta.type = 'button';
    cta.id = 'fcrBook';
    cta.appendChild(nIcon('fa-solid ' + (sold || reserved ? 'fa-bell' : 'fa-calendar-check')));
    cta.appendChild(document.createTextNode(
      sold ? ' Подобрать похожую' : (reserved ? ' Сообщить, если освободится' : ' Забронировать')));
    card.appendChild(cta);

    // ── короткая форма с номером ──
    // ⛔ У ПРОДАННОЙ квартиры её нет: следить за ценой лота, который уже не купить,
    //    бессмысленно, а форма перебила бы правильное «подобрать похожую».
    if (!sold) card.appendChild(buildQuick());

    // ── прямой телефон (на телефоне прячет CSS: он уже в шапке и в панели) ──
    const tel = document.createElement('a');
    tel.className = 'fcr-phone';
    tel.href = 'tel:+79191701918';
    tel.appendChild(nIcon('fas fa-phone'));
    tel.appendChild(document.createTextNode(' 8 (919) 170-19-18'));
    card.appendChild(tel);

    card.appendChild(nEl('div', 'fcr-note', 'Ответим за 5 минут. Александр, ваш персональный брокер'));

    // ⛔ ПОЧИНКА: старый блок печатал «0 просмотров» буквально — страница сама себе
    //    выписывала справку «сюда никто не заходил». Показываем строку только когда
    //    просмотры есть, и склоняем слово по-русски.
    const views = parseInt(FLAT.views, 10) || 0;
    if (views > 0) {
      const v = nEl('div', 'fcr-views');
      v.appendChild(nIcon('fa-regular fa-eye'));
      v.appendChild(document.createTextNode(' ' + views + ' ' + plural(views, 'просмотр', 'просмотра', 'просмотров')));
      card.appendChild(v);
    }

    return card;
  }

  /* ═══ КОРОТКИЙ ВХОД: НОМЕР ПРЯМО В КАРТОЧКЕ СДЕЛКИ ═══

     ⛔ СЛОВО ВЛАДЕЛЬЦА, дословно: «На карточке квартиры вместо "Следить за ценой"
        пусть вместо этого поля сделает ввод номера и отправить прям со страницы,
        без модального окна».

     Было: кнопка «Следить за ценой» прокручивала вниз к большой форме заявки и
     меняла ей заголовок. То есть номер человек всё равно вводил не здесь.

     ⛔ ЭТО ВТОРОЙ ВХОД, А НЕ ЗАМЕНА. Большая форма заявки внизу остаётся: там полная
        заявка с именем, здесь — короткий путь в одно поле. Кнопка «Забронировать»
        остаётся главной: она выше, крупнее и золотая.

     ⛔ СОГЛАСИЕ НА ОБРАБОТКУ ПДн — ОБЯЗАТЕЛЬНО (152-ФЗ, ст. 9 ч. 4). Текст и ссылка
        взяты ДОСЛОВНО из формы заявки на этой же странице (блок flatBookConsent в
        app/templates/pages/flat_content.php). Своей формулировки не сочиняем: за неё
        отвечает юрист, а не вёрстка. Раз текст не менялся — bump PDN_TEXT_VERSION
        не нужен. Галочка по умолчанию СНЯТА: заранее отмеченное согласие недействительно.

     ⛔ ПОЛЕ НОМЕРА — ОБЫЧНОЕ `type="tel"` С ТЕМИ ЖЕ ПРИЗНАКАМИ, ЧТО У ОСТАЛЬНЫХ
        ПОЛЕЙ ТЕЛЕФОНА САЙТА (name="phone", ym-hide-content, data-ym-disable-keys,
        autocomplete="tel" — см. app/templates/components/lead-form.php). Своего
        разбора номера здесь НЕТ намеренно: общий обработчик подсказки «+7» цепляет
        поля по этим признакам, и вторая реализация разошлась бы с ним при первой
        же правке. Проверка ниже — не разбор, а единственный вопрос «цифр меньше
        десяти?»: набрать российский номер короче невозможно.

     ⛔ ЗАЩИТА ФОРМЫ — ТА ЖЕ, ЧТО У РАБОЧЕЙ. Ловушка `_hp` (скрытое поле, которое
        человек не видит, а робот заполняет), тот же адрес `/map_api.php?action=apply`
        и то же тело запроса — значит и серверные проверки (`checkPublicForm`:
        источник запроса и ловушка, плюс `checkFormRate`) отрабатывают ровно те же. */
  function buildQuick() {
    const form = document.createElement('form');
    form.className = 'fcr-quick';
    form.id = 'fcrQuick';
    form.noValidate = true;

    // ⛔ 24.08.2026, решение владельца: подпись была «Сообщим, если цена изменится», и она
    // ВРАЛА о том, что происходит. Форма шлёт заявку тем же адресом и тем же телом, что
    // большая форма внизу страницы, — то есть создаёт обращение, а не подписку на цену.
    // Слежения за ценой в коде нет вовсе. Текст согласия («для подбора объекта
    // недвижимости») с самого начала описывал заявку, а не рассылку. Подпись приведена
    // к делу: «Оставить заявку».
    form.appendChild(nEl('div', 'fcr-quick-title', 'Оставить заявку'));

    const row = nEl('div', 'fcr-quick-row');
    const inp = document.createElement('input');
    inp.type = 'tel';                 // на телефоне открывается цифровая клавиатура
    inp.name = 'phone';
    inp.className = 'fcr-quick-input ym-hide-content';
    inp.placeholder = '+7 (___) ___-__-__';
    inp.autocomplete = 'tel';
    inp.inputMode = 'tel';
    inp.setAttribute('aria-label', 'Ваш номер телефона');
    // Тот же запрет на попадание номера в счётчик, что стоит у рабочей формы.
    inp.setAttribute('data-ym-disable-keys', 'true');
    row.appendChild(inp);

    const btn = nEl('button', 'fcr-quick-btn');
    btn.type = 'submit';
    btn.setAttribute('aria-label', 'Отправить номер');
    btn.appendChild(nIcon('fa-solid fa-arrow-right'));
    row.appendChild(btn);
    form.appendChild(row);

    // Ловушка для роботов. Прячет её CSS; человек этого поля не видит.
    const hp = document.createElement('input');
    hp.type = 'text';
    hp.name = '_hp';
    hp.className = 'fcr-quick-hp';
    hp.tabIndex = -1;
    hp.autocomplete = 'off';
    hp.setAttribute('aria-hidden', 'true');
    form.appendChild(hp);

    // ── Согласие. Текст — дословная копия из формы заявки этой же страницы. ──
    const cons = nEl('label', 'fcr-quick-consent');
    const chk = document.createElement('input');
    chk.type = 'checkbox';
    chk.name = 'consent_main';
    chk.value = '1';
    chk.className = 'fcr-quick-chk';
    chk.id = 'fcrQuickConsent';
    cons.htmlFor = 'fcrQuickConsent';
    cons.appendChild(chk);
    const consText = nEl('span', 'fcr-quick-consent-text');
    consText.appendChild(document.createTextNode(
      'Согласен на обработку моих ПДн (имя, телефон) для подбора объекта недвижимости. '));
    const a = document.createElement('a');
    a.href = '/soglasie.php';
    a.target = '_blank';
    a.rel = 'noopener';
    a.className = 'fcr-quick-consent-link';
    a.textContent = 'Согласие на обработку ПДн';
    consText.appendChild(a);
    consText.appendChild(document.createTextNode('.'));
    cons.appendChild(consText);
    form.appendChild(cons);

    // Место для ошибки. `role="alert"` — чтобы её прочитал экранный диктор,
    // а не только увидел зрячий.
    const err = nEl('div', 'fcr-quick-err');
    err.setAttribute('role', 'alert');
    form.appendChild(err);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      err.textContent = '';
      form.classList.remove('is-bad-phone', 'is-bad-consent');

      const digits = String(inp.value || '').replace(/\D+/g, '');
      if (digits.length === 0) {
        err.textContent = 'Введите номер телефона';
        form.classList.add('is-bad-phone');
        inp.focus();
        return;
      }
      // 10 цифр — номер без «восьмёрки», 11 — с ней. Меньше десяти набрать
      // российский номер невозможно, значит это опечатка, а не другой формат.
      if (digits.length < 10) {
        err.textContent = 'Номер короткий — в нём должно быть 10 цифр';
        form.classList.add('is-bad-phone');
        inp.focus();
        return;
      }
      if (!chk.checked) {
        err.textContent = 'Отметьте согласие на обработку персональных данных';
        form.classList.add('is-bad-consent');
        chk.focus();
        return;
      }

      const body = {
        name: '',
        phone: inp.value,
        _hp: hp.value,
        flat_id: FLAT.id,
        building_id: FLAT.building_id,
        building_name: FLAT.building_name,
        type: 'booking',
        source: 'flat_price_watch',
      };
      // ⛔ СОГЛАСИЕ НЕ ХАРДКОДИМ (152-ФЗ, ст. 9 ч. 4 — фикция согласия запрещена).
      //    Выше стоит проверка «галочка не отмечена → выходим», и соблазн написать
      //    поле согласия единицей прямо в теле велик: сюда и правда доходят только
      //    отметившие. Но тогда согласие держится на ПОРЯДКЕ СТРОК, а не на факте:
      //    любая будущая правка проверки — и запрос уносит согласие, которого
      //    человек не давал. Читаем состояние самого чекбокса, как это делает
      //    большая форма заявки ниже по файлу. Запрет пришпилен грепом
      //    tests/Integration/flat-catalog.test.mjs — грепом по исходнику, поэтому
      //    и в КОММЕНТАРИИ запретную пару «поле: единица» писать нельзя: греп
      //    кода от прозы не отличает, и объяснение запрета уронило бы запрет.
      if (chk.checked) body.consent_main = '1';
      // Ключ защиты от подделки запроса — из уже отрисованной формы страницы,
      // второго источника не заводим.
      const csrf = document.querySelector('#flatBookingForm input[name="_csrf"]');
      if (csrf && csrf.value) body._csrf = csrf.value;

      btn.disabled = true;
      inp.disabled = true;

      const done = () => {
        // ⚠️ Имя цели осталось прежним НАМЕРЕННО, хотя подпись формы сменилась на
        // «Оставить заявку». Цель заводится вручную в кабинете Метрики: переименуй здесь —
        // и счёт молча прекратится, потому что там останется старое имя. Менять только
        // вместе с кабинетом, одним действием. Долг записан владельцу.
        if (typeof ymGoal === 'function') ymGoal('flat_price_watch_submit');
        form.textContent = '';
        const ok = nEl('div', 'fcr-quick-ok');
        ok.appendChild(nIcon('fa-solid fa-circle-check'));
        // Обещаем то, что действительно делаем: по заявке звонит человек.
        // Прежний текст обещал уведомление о цене, которого механизм не отправляет.
        ok.appendChild(document.createTextNode(' Заявка принята. Перезвоним и ответим на вопросы.'));
        form.appendChild(ok);
      };
      const fail = (msg) => {
        btn.disabled = false;
        inp.disabled = false;
        err.textContent = msg;
      };

      fetch('/map_api.php?action=apply', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then((data) => { if (data && data.ok) done(); else fail((data && data.error) || 'Не отправилось, попробуйте ещё раз'); })
        .catch(() => fail('Нет связи — попробуйте ещё раз'));
    });

    return form;
  }

  /* ═══ ЖИВОЙ КАЛЬКУЛЯТОР ИПОТЕКИ ПРЯМО В КАРТОЧКЕ ═══

     ⛔ ПОЧЕМУ ЗДЕСЬ НЕТ БАНКОВСКИХ СТАВОК ИЗ БАЗЫ, ХОТЯ ОНИ ЕСТЬ.
        В базе лежат программы и ставки, но до карточки квартиры они не доходят —
        и доводить их СКРИПТОМ нельзя: показанная ставка обязывает раскрыть ПСК
        (ст. 28 ч. 3 38-ФЗ), а раскрытие обязан печатать сервер. Правило записано
        в шапке app/lib/Mortgage/BuyWays.php: «ставки и юр-строку печатает СЕРВЕР,
        скрипт только считает платёж по уже напечатанным числам». Поэтому ставку
        двигает сам человек, а за программами калькулятор ведёт на /mortgage.php,
        где раскрытие уже есть. */
  function buildCalc() {
    const frag = document.createDocumentFragment();

    const toggle = nEl('button', 'fcr-calc-toggle');
    toggle.type = 'button';
    toggle.setAttribute('aria-expanded', 'false');
    const tl = nEl('span', null, 'Подобрать платёж под себя');
    toggle.appendChild(tl);
    toggle.appendChild(nIcon('fa-solid fa-chevron-down fcr-chev'));
    frag.appendChild(toggle);

    const box = nEl('div', 'fcr-calc');
    box.id = 'fcrCalc';
    box.hidden = true;

    // Один ряд ползунка: подпись, значение, сама дорожка.
    function row(id, label, min, max, step, value, suffix) {
      const r = nEl('div', 'fcr-calc-row');
      const head = nEl('div', 'fcr-calc-head');
      head.appendChild(nEl('span', null, label));
      const val = nEl('b', null, '');
      val.id = id + 'Val';
      head.appendChild(val);
      r.appendChild(head);
      const inp = document.createElement('input');
      inp.type = 'range';
      inp.className = 'fcr-range';
      inp.id = id;
      inp.min = String(min);
      inp.max = String(max);
      inp.step = String(step);
      inp.value = String(value);
      inp.setAttribute('aria-label', label + (suffix ? ', ' + suffix : ''));
      r.appendChild(inp);
      box.appendChild(r);
      return { input: inp, out: val };
    }

    const down = row('fcrDown', 'Первоначальный взнос', 10, 90, 5, CALC_DOWN, 'процентов');
    const years = row('fcrYears', 'Срок кредита', 3, 30, 1, CALC_YEARS, 'лет');
    const rate = row('fcrRate', 'Ставка', 0.1, 30, 0.1, CALC_RATE, 'процентов годовых');

    const out = nEl('div', 'fcr-calc-out');
    out.appendChild(nEl('span', 'fcr-calc-out-label', 'Платёж в месяц'));
    const outVal = nEl('span', 'fcr-calc-out-val', '—');
    outVal.id = 'fcrCalcOut';
    outVal.setAttribute('aria-live', 'polite');
    out.appendChild(outVal);
    box.appendChild(out);

    const sum = nEl('div', 'fcr-calc-sum', '');
    sum.id = 'fcrCalcSum';
    box.appendChild(sum);

    const link = document.createElement('a');
    link.className = 'fcr-calc-link';
    link.href = '/mortgage.php';
    link.textContent = 'Программы, ставки и условия →';
    box.appendChild(link);

    frag.appendChild(box);

    const nf = new Intl.NumberFormat('ru-RU');

    function update() {
      const d = parseInt(down.input.value, 10);
      const y = parseInt(years.input.value, 10);
      const r = parseFloat(rate.input.value);
      const loan = Math.round(FLAT.price * (1 - d / 100));
      const m = calcMonthly(FLAT.price, d, r, y);

      down.out.textContent = d + '% · ' + nf.format(Math.round(FLAT.price * d / 100)) + ' ₽';
      years.out.textContent = y + ' ' + plural(y, 'год', 'года', 'лет');
      rate.out.textContent = r.toFixed(1).replace('.', ',') + '%';
      outVal.textContent = nf.format(m) + ' ₽';
      sum.textContent = 'Сумма кредита ' + nf.format(loan) + ' ₽ · переплата '
        + nf.format(Math.max(0, m * y * 12 - loan)) + ' ₽ за весь срок';

      // Строка «В ипотеку от … /мес» наверху карточки идёт следом за ползунками:
      // два числа об одном и том же не должны расходиться на одном экране.
      const head = $('fcrMortgageVal');
      const hint = $('fcrMortgageHint');
      if (head) head.textContent = nf.format(m) + ' ₽/мес';
      if (hint) hint.textContent = d + '% взнос · ' + r.toFixed(1).replace('.', ',') + '% · ' + y + ' ' + plural(y, 'год', 'года', 'лет');
    }

    [down.input, years.input, rate.input].forEach((i) => i.addEventListener('input', update));

    toggle.addEventListener('click', () => {
      const open = box.classList.contains('is-open');
      const flip = () => {
        box.classList.toggle('is-open', !open);
        box.hidden = open;
        toggle.setAttribute('aria-expanded', String(!open));
        tl.textContent = open ? 'Подобрать платёж под себя' : 'Свернуть расчёт';
      };
      // Плавное раскрытие средствами браузера, без анимационных библиотек.
      if (document.startViewTransition) { document.startViewTransition(flip); } else { flip(); }
      if (!open) update();
    });

    update();
    return frag;
  }

  /* ═══ НАДЁЖНОСТЬ ═══
     ⛔ Пишем только то, что правда для ЭТОГО объекта. Строящийся дом по ДДУ с 2019
        года обязан продавать через эскроу — это закон, не догадка. У сданного дома
        этой строки нет.

     ⛔ ПРОЕКТНАЯ ДЕКЛАРАЦИЯ — строка зелёная по прямому слову владельца 23.08:
        «они есть все на ДОМ.РФ, я проверил». Проверял он, не мы, и это записано
        здесь, а не подразумевается.

        Почему не даём ссылку на сам документ. В базе НЕТ НИ ОДНОЙ: замер 23.08 —
        `declaration_url` 0 из 153, `domrf_id` 0 из 153, `escrow_bank` 0 из 153,
        таблица `building_cadastral` пуста. Поэтому ведём в ПОИСК наш.дом.рф по
        названию ЖК: ссылка рабочая, обещание выполнимое, и мы не утверждаем номер
        и дату документа, которых не видели.

     ⛔ КОГДА ПОЯВИТСЯ КЛЮЧ DOMRF_API_KEY — заменить на конкретику: «Проектная
        декларация от <дата>» со ссылкой на сам документ и строкой про банк эскроу. */
  function buildTrust() {
    const box = nEl('div', 'fcr-trust');
    box.id = 'fcrTrust';
    box.appendChild(nEl('div', 'fcr-trust-title', 'Надёжность'));

    const add = (text) => {
      const row = nEl('div', 'fcr-trust-row');
      row.appendChild(nIcon('fa-solid fa-circle-check'));
      row.appendChild(document.createTextNode(' ' + text));
      box.appendChild(row);
    };

    /* Зелёная строка со ссылкой. Отдельно от add(), потому что там текст —
       обычный узел, а здесь нужна ссылка. */
    const addLink = (text, linkText, href) => {
      const row = nEl('div', 'fcr-trust-row');
      row.appendChild(nIcon('fa-solid fa-circle-check'));
      row.appendChild(document.createTextNode(' ' + text + ' '));
      const a = nEl('a', 'fcr-trust-link', linkText);
      a.href = href;
      a.target = '_blank';
      // ⛔ Без rel="noopener" открытая страница получает ссылку на наше окно
      //    (window.opener) и может, например, подменить в нём адрес. Это дыра,
      //    а не мелочь.
      a.rel = 'noopener';
      row.appendChild(a);
      box.appendChild(row);
    };

    if (String(FLAT.building_status || '') === 'building') {
      add('Договор долевого участия по 214-ФЗ');
      add('Деньги покупателя лежат на эскроу-счёте до сдачи дома');
    } else {
      add('Дом сдан, продажа по договору купли-продажи');
    }
    if (FLAT.developer) add('Застройщик: ' + String(FLAT.developer));

    /* Поиск по названию ЖК: ведём туда, где документ лежит, а не выдумываем его адрес. */
    const jkName = String(FLAT.jk_name || FLAT.building_name || '').trim();
    addLink(
      'Проектная декларация опубликована на наш.дом.рф',
      jkName ? '— найти «' + jkName + '»' : '— открыть реестр',
      jkName ? DOMRF_CATALOG + '?objVal=' + encodeURIComponent(jkName) : DOMRF_CATALOG
    );
    return box;
  }

  /* ═══ ЭТА КВАРТИРА ПРОТИВ ДРУГИХ В ДОМЕ ═══

     ⛔ ОДИН ЗАПРОС ВМЕСТО ТРЁХ. Черновик спрашивал `flat_api.php?action=list`
        три раза (самая дешёвая · самая дорогая · дешевле нашей): ~4 КБ по сети
        и ТРИ похода в базу ради четырёх чисел, на каждый просмотр каждой из
        40 846 карточек. Теперь это один агрегат `action=compare`
        (FlatHandler::compareInBuilding) — один запрос, один поход в базу.

     ⛔ «ПОХОЖИЕ» — ЭТА ЖЕ КОМНАТНОСТЬ И ПЛОЩАДЬ ±3 м². Сравнивать нашу
        двухкомнатную со ВСЕМИ двухкомнатными дома нечестно: там есть и 45 м²,
        они дешевле просто потому, что меньше. Замер это подтвердил: среди всех
        112 двухкомнатных «Дюны» наша дороже 37, а среди 69 похожих по площади
        она самая дешёвая. Первое число настоящее, но отвечает не на тот вопрос. */

  async function buildVs() {
    const bid = parseInt(FLAT.building_id, 10) || 0;
    const area = parseFloat(FLAT.area) || 0;
    if (!bid || !area || !(FLAT.price > 0)) return null;

    const q = new URLSearchParams({
      building_id: String(bid),
      rooms: String(parseInt(FLAT.rooms, 10) || 0),
      area: String(area),
      price: String(FLAT.price),
      area_window: String(VS_AREA_WINDOW),
    }).toString();

    let data = null;
    try {
      const r = await fetch(API + '?action=compare&' + q, { credentials: 'same-origin' });
      data = r.ok ? await r.json() : null;
    } catch {
      data = null;
    }
    // ⛔ Нет ответа — блока нет. Пустая рамка «данные не загрузились» хуже, чем
    //    отсутствие блока: она обещает и не даёт.
    if (!data || !data.ok) return null;

    const total = parseInt(data.total, 10) || 0;
    if (total < VS_MIN_SIMILAR) return null;

    const minP = parseInt(data.min_price, 10) || 0;
    const maxP = parseInt(data.max_price, 10) || 0;
    // `cheaper_or_same` считает квартиры с ценой НЕ ВЫШЕ нашей — в это число входит
    // и она сама, поэтому мест ниже нас на одно меньше.
    const belowIncl = Math.max(1, parseInt(data.cheaper_or_same, 10) || 1);
    const below = Math.max(0, belowIncl - 1);
    const above = Math.max(0, total - belowIncl);

    const nf = new Intl.NumberFormat('ru-RU');
    const areaMin = (area - VS_AREA_WINDOW).toFixed(1);
    const areaMax = (area + VS_AREA_WINDOW).toFixed(1);

    const box = nEl('section', 'fcr-vs');
    box.id = 'fcrVs';

    const h = nEl('h2', 'fcr-vs-title');
    h.appendChild(nIcon('fa-solid fa-scale-balanced'));
    h.appendChild(document.createTextNode(' Эта квартира против других в доме'));
    box.appendChild(h);

    // ⛔ У ПРОДАННОЙ КВАРТИРЫ МЕСТО В РЯДУ НЕ СЧИТАЕМ. Её цена — прошлая (в карточке
    //    сделки честно стоит «цена на такое-то число, когда лот сняли с продажи»),
    //    а сравнивали бы мы её с ЖИВЫМИ ценами соседей. Число вышло бы настоящим,
    //    а предмет — чужим. Показываем то, что здесь и правда полезно: сколько
    //    похожих в доме продаётся СЕЙЧАС и по какой цене.
    const soldPage = document.querySelector('.flat-sold-banner') !== null;

    // ⛔ Число похожих здесь НЕ повторяем: оно уже стоит в выводе ниже и на плитке.
    //    Три раза одно и то же число на одном экране — не подтверждение, а шум.
    box.appendChild(nEl('div', 'fcr-vs-sub',
      'Сравниваем с квартирами того же дома: ' + roomsLabel(FLAT.rooms).toLowerCase()
      + ', площадь от ' + fmtArea(areaMin) + ' до ' + fmtArea(areaMax) + ' м².'));

    // ── главный вывод ──
    const verdict = nEl('div', 'fcr-vs-verdict');
    if (soldPage) {
      verdict.appendChild(document.createTextNode('Эта квартира снята с продажи. '
        + 'Похожих в этом доме сейчас продаётся '));
      verdict.appendChild(nEl('b', null, String(total)));
      verdict.appendChild(document.createTextNode('.'));
    } else if (below === 0) {
      verdict.classList.add('is-good');
      verdict.appendChild(document.createTextNode('Дешевле этой квартиры среди '
        + total + ' похожих — '));
      verdict.appendChild(nEl('b', null, 'ни одной'));
      verdict.appendChild(document.createTextNode('.'));
    } else if (above === 0) {
      verdict.appendChild(document.createTextNode('Это самая дорогая из '
        + total + ' похожих квартир дома.'));
    } else if (above >= below) {
      verdict.classList.add('is-good');
      verdict.appendChild(document.createTextNode('Дешевле, чем '));
      verdict.appendChild(nEl('b', null, above + ' из ' + total));
      verdict.appendChild(document.createTextNode(' похожих квартир этого дома.'));
    } else {
      verdict.appendChild(document.createTextNode('Дороже, чем '));
      verdict.appendChild(nEl('b', null, below + ' из ' + total));
      verdict.appendChild(document.createTextNode(' похожих квартир этого дома.'));
    }
    box.appendChild(verdict);

    // ── шкала: где эта цена между самой дешёвой и самой дорогой похожей ──
    if (maxP > minP && !soldPage) {
      const scale = nEl('div', 'fcr-scale');
      const track = nEl('div', 'fcr-scale-track');
      const pin = nEl('div', 'fcr-scale-pin');
      pin.setAttribute('role', 'img');
      const pct = Math.max(0, Math.min(100, (FLAT.price - minP) / (maxP - minP) * 100));
      pin.setAttribute('aria-label', 'Цена этой квартиры на шкале похожих');
      // Метка выезжает из левого края: `left` меняем ПОСЛЕ вставки в страницу,
      // иначе переход стартовать не с чего и движения не будет.
      pin.dataset.left = pct.toFixed(1) + '%';
      track.appendChild(pin);
      scale.appendChild(track);
      const ends = nEl('div', 'fcr-scale-ends');
      ends.appendChild(nEl('span', null, 'самая дешёвая ' + nf.format(minP) + ' ₽'));
      ends.appendChild(nEl('span', null, nf.format(maxP) + ' ₽ самая дорогая'));
      scale.appendChild(ends);
      box.appendChild(scale);
    }

    // ── плитки с числами ──
    const grid = nEl('div', 'fcr-vs-grid');
    const cell = (val, lbl) => {
      const c = nEl('div', 'fcr-vs-cell');
      c.appendChild(nEl('div', 'fcr-vs-cell-val', val));
      c.appendChild(nEl('div', 'fcr-vs-cell-lbl', lbl));
      grid.appendChild(c);
    };

    cell(String(total), 'похожих квартир в доме сейчас в продаже');

    if (soldPage) {
      // У снятого лота показываем не «место в ряду», а живой диапазон соседей —
      // это то, за чем человек сюда и пришёл после того, как увидел «продана».
      if (maxP > minP) cell(nf.format(minP) + ' ₽', 'самая дешёвая из них сейчас');
    } else if (maxP > FLAT.price) {
      cell(nf.format(maxP - FLAT.price) + ' ₽', 'разница с самой дорогой похожей');
    }

    if (FLAT.floor && FLAT.floors_total) {
      const f = parseInt(FLAT.floor, 10), ft = parseInt(FLAT.floors_total, 10);
      let where = 'середина дома';
      if (ft > 0) {
        if (f <= Math.ceil(ft / 3)) where = 'нижняя треть дома';
        else if (f > Math.ceil(ft * 2 / 3)) where = 'верхняя треть дома';
      }
      cell(f + ' из ' + ft, 'этаж — ' + where);
    }

    // ⛔ avg_price_m2 приходит в данных страницы и считается по ВСЕМ комнатностям
    //    дома. Однокомнатные всегда дороже за метр, поэтому подпись обязана это
    //    называть — иначе число выглядит сравнением равного с равным, а это не так.
    const avg = parseInt(FLAT.avg_price_m2, 10) || 0;
    const our = parseInt(FLAT.price_m2, 10) || 0;
    let avgShown = false;
    if (avg > 0 && our > 0 && !soldPage) {
      const diff = Math.round((our - avg) / avg * 100);
      cell((diff <= 0 ? '−' : '+') + Math.abs(diff) + '%',
        'к средней цене метра по дому — ' + nf.format(avg) + ' ₽/м²');
      avgShown = true;
    }

    box.appendChild(grid);
    // ⛔ Оговорка про среднюю цену метра печатается ТОЛЬКО когда эта плитка есть.
    //    Иначе примечание объясняло бы число, которого на экране нет.
    box.appendChild(nEl('div', 'fcr-vs-note',
      'Считаем по нашей базе на момент открытия страницы: только квартиры, которые '
      + 'сейчас в продаже в этом доме.'
      + (avgShown
        ? ' Средняя цена метра по дому взята по всем комнатностям сразу — '
          + 'однокомнатные всегда дороже за метр, это надо учитывать.'
        : '')));

    return box;
  }

  /* ═══ РАЗБОР ПЛОЩАДИ ═══

     Поля `living_area`, `kitchen_area`, `rooms_area` в базе есть, а на странице их
     видно только строчками в характеристиках — без соотношения. Замер 23.08 по
     40 880 квартирам в продаже:
       жилая площадь заполнена у 35 682 (87 %)
       кухня                    у 24 770 (61 %)
       площади комнат порознь   у  1 325 (3 %)

     ⛔ «ОСТАЛЬНОЕ» ПОДПИСЫВАЕТСЯ ПО-РАЗНОМУ. Когда кухня известна, она вычтена и в
        остатке коридор, санузлы, лоджия. Когда кухни в базе нет (а это каждая
        третья квартира) — кухня сидит внутри остатка, и подпись обязана это
        сказать. Иначе человек посчитает, что кухни нет. */
  function buildArea() {
    const total = parseFloat(FLAT.area) || 0;
    const living = parseFloat(FLAT.living_area) || 0;
    const kitchen = parseFloat(FLAT.kitchen_area) || 0;
    // Без жилой площади разбирать нечего: одна общая площадь и так в характеристиках.
    if (total <= 0 || living <= 0 || living >= total) return null;

    const rest = Math.round((total - living - kitchen) * 10) / 10;
    if (rest < 0) return null;   // мусор в фиде — молча не рисуем

    const box = nEl('section', 'fcr-area');
    box.id = 'fcrArea';

    const h = nEl('h2', 'fcr-area-title');
    h.appendChild(nIcon('fa-solid fa-ruler-combined'));
    h.appendChild(document.createTextNode(' Из чего складываются ' + fmtArea(total) + ' м²'));
    box.appendChild(h);

    const bar = nEl('div', 'fcr-area-bar');
    const seg = (cls, val, label) => {
      const s = nEl('div', 'fcr-area-seg ' + cls);
      s.dataset.grow = String(Math.max(0, val));
      s.textContent = Math.round(val / total * 100) >= 12 ? label : '';
      s.title = label;
      bar.appendChild(s);
    };
    seg('is-living', living, fmtArea(living) + ' м²');
    if (kitchen > 0) seg('is-kitchen', kitchen, fmtArea(kitchen) + ' м²');
    if (rest > 0) seg('is-rest', rest, fmtArea(rest) + ' м²');
    box.appendChild(bar);

    const legend = nEl('div', 'fcr-area-legend');
    const item = (cls, val, name) => {
      const i2 = nEl('div', 'fcr-area-item');
      i2.appendChild(nEl('span', 'fcr-area-dot ' + cls));
      i2.appendChild(nEl('b', null, fmtArea(val) + ' м²'));
      i2.appendChild(nEl('span', null, name));
      legend.appendChild(i2);
    };
    item('is-living', living, 'жилая — комнаты');
    if (kitchen > 0) item('is-kitchen', kitchen, 'кухня');
    if (rest > 0) {
      item('is-rest', rest, kitchen > 0
        ? 'коридор, санузлы, балкон'
        : 'кухня, коридор, санузлы, балкон');
    }
    box.appendChild(legend);

    // Площади комнат по отдельности — есть всего у 3 % квартир (1 325 из 40 880).
    // Из шести конкурентов их показывает только Яндекс.
    const ra = String(FLAT.rooms_area || '').trim();
    if (ra) {
      const ul = nEl('ul', 'fcr-rooms');
      // «-» — прежний разделитель комнат ГАЛС, «+» — ЦИАН, «;» — нейтральный.
      // Десятичная запятая внутри числа не создаёт новую комнату. Одиночное
      // «12,14» считаем числом; список с запятыми требует пробела или иных чисел.
      // Знак отрицательного числа и текстовый диапазон сохраняем как исходный текст.
      const parts = /^\d+(?:[.,]\d+)?(?:\s*[+\-;|]\s*\d+(?:[.,]\d+)?)*$/.test(ra)
        ? ra.split(/\s*[+\-;|]\s*/)
        : /^\d+(?:\.\d+)?(?:\s*,\s*\d+(?:\.\d+)?)+$/.test(ra)
          ? ra.split(/\s*,\s*/)
          : ra.split(/[;|]/);
      parts.map((s) => s.trim()).filter((s) => s && !/^,+$/.test(s)).forEach((s, i) => {
        ul.appendChild(nEl('li', null, 'комната ' + (i + 1) + ' — ' + s.replace(/\./g, ',') + ' м²'));
      });
      if (ul.children.length) box.appendChild(ul);
    }

    box.appendChild(nEl('div', 'fcr-area-note', kitchen > 0
      ? 'Жилая и кухня — из данных застройщика. Остальное — разница с общей площадью.'
      : 'Площадь кухни застройщик в этом объявлении не передал, поэтому она входит '
        + 'в «остальное». Жилая площадь и общая — из данных застройщика.'));

    return box;
  }

  /* ═══ ПЛАВНОСТЬ ═══
     Доли площадей и метка на шкале выезжают из нуля, когда блок доехал до экрана.
     Начальные значения ставит скрипт — тот же, что рисует блоки: если скрипта нет,
     нет и блоков, прятать нечего.

     ⛔ Долю пишем в `flex-grow` через свойство элемента, а не строкой в CSS: число
        вычисляется из площади конкретной квартиры, в таблицу стилей его положить
        нельзя. Это единственное место, где вид задаётся числом из данных. */
  function revealArea(box) {
    const segs = box.querySelectorAll('.fcr-area-seg');
    segs.forEach((s) => { s.style.flexGrow = '0'; s.style.flexBasis = '0'; });
    reveal(box);
    const run = () => segs.forEach((s) => { s.style.flexGrow = s.dataset.grow || '0'; });
    if (typeof IntersectionObserver === 'function') {
      const obs = new IntersectionObserver((es) => {
        es.forEach((e) => { if (e.isIntersecting) { run(); obs.disconnect(); } });
      }, { rootMargin: '0px 0px -40px 0px' });
      obs.observe(box);
    } else {
      run();
    }
  }

  function revealScale(box) {
    const pin = box.querySelector('.fcr-scale-pin');
    if (pin) pin.style.left = '0%';
    reveal(box);
    const run = () => { if (pin) pin.style.left = pin.dataset.left || '0%'; };
    if (typeof IntersectionObserver === 'function') {
      const obs = new IntersectionObserver((es) => {
        es.forEach((e) => { if (e.isIntersecting) { setTimeout(run, 120); obs.disconnect(); } });
      }, { rootMargin: '0px 0px -40px 0px' });
      obs.observe(box);
    } else {
      run();
    }
  }

  /* ═══ ЗАМЕНА СЕРВЕРНОЙ КАРТОЧКИ БЕЗ ПОТЕРИ ВВОДА ═══
     ⛔ 6.2 realty-feed-guard (доводка r2, 24.09.2026). Серверная карточка видна ДО
     скрипта, и в её поле номера можно успеть набрать телефон и отметить согласие (на
     медленной сети — легко). Простая замена узла стирала набранное, снимала галочку и
     уводила фокус: человек видел, как его номер исчез (находка внешнего проверяющего,
     проба visual.mjs --input-only). Поэтому переносим в собранную скриптом карточку то,
     что человек успел изменить, и фокус с кареткой. Деревья совпадают узел в узел
     (tests/Integration/flat-server-facts-mirror.test.mjs), поэтому поля сопоставляются
     по порядку, а фокус — по пути от корня карточки. Галочку согласия переносим только
     ту, что человек поставил САМ: у серверной формы она по умолчанию снята, как у нашей. */
  function swapKeepingInput(from, to) {
    const src = from.querySelectorAll('input');
    const dst = to.querySelectorAll('input');
    src.forEach((a, i) => {
      const b = dst[i];
      if (!b || b.type !== a.type || b.name !== a.name) return;
      if (a.type === 'checkbox' || a.type === 'radio') {
        if (a.checked !== a.defaultChecked) b.checked = a.checked;
      } else if (a.value !== a.defaultValue) {
        b.value = a.value;
      }
    });

    const active = document.activeElement;
    const path = [];
    if (active && active !== from && from.contains(active)) {
      for (let n = active; n !== from; n = n.parentElement) {
        path.unshift(Array.prototype.indexOf.call(n.parentElement.children, n));
      }
    }
    let caret = null;
    try {
      if (path.length && typeof active.selectionStart === 'number') {
        caret = [active.selectionStart, active.selectionEnd];
      }
    } catch (_e) { /* у поля без каретки свойство бросает — каретки и нет */ }

    from.replaceWith(to);

    if (!path.length) return;
    let target = to;
    for (let k = 0; k < path.length && target; k++) target = target.children[path[k]];
    if (!target || typeof target.focus !== 'function') return;
    target.focus({ preventScroll: true });
    if (caret) {
      try { target.setSelectionRange(caret[0], caret[1]); } catch (_e) { /* см. выше */ }
    }
  }

  /* ═══ СБОРКА ═══ */
  function renderDeal() {
    const rail = $('flatRail');
    // ⛔ 6.2 realty-feed-guard (доводка r1, 24.09.2026): КАРТОЧКУ СДЕЛКИ И «НАДЁЖНОСТЬ»
    //    УЖЕ НАПЕЧАТАЛ СЕРВЕР (app/lib/Seo/FlatDealCard.php, метка data-ssr) — на том же
    //    месте и в той же разметке, для тех, кто скрипт не исполняет. Здесь собираем свои
    //    и ЗАМЕНЯЕМ ими серверные в одном проходе, без отрисовки между: вид тот же, дубля
    //    нет, а кнопки и калькулятор получают обработчики. Правишь buildDeal/buildTrust/
    //    buildCalc/buildQuick — правь и FlatDealCard, иначе карточка мигнёт; расхождение
    //    ловит tests/Integration/flat-server-facts-mirror.test.mjs.
    const ssrDeal = $('fcrDeal');
    if (!rail || (ssrDeal && !ssrDeal.hasAttribute('data-ssr'))) return;

    const deal = buildDeal();
    const trust = buildTrust();
    const ssrTrust = $('fcrTrust');
    if (ssrDeal) {
      swapKeepingInput(ssrDeal, deal);
      if (ssrTrust && ssrTrust.hasAttribute('data-ssr')) swapKeepingInput(ssrTrust, trust);
      else deal.after(trust);
    } else {
      rail.insertBefore(trust, rail.firstChild);
      rail.insertBefore(deal, rail.firstChild);
    }

    // ⛔ Класс вешаем ПОСЛЕ вставки карточки: под ним прячется старый блок цены,
    //    и до появления замены прятать нечего (см. шапку раздела).
    document.documentElement.classList.add('fcr-on');

    bindDeal();

    // ── Разбор площади. Синхронный: данные уже на странице. ──
    const specs = $('flatSpecs');
    const areaBox = buildArea();
    if (areaBox && specs && specs.parentNode) {
      specs.parentNode.insertBefore(areaBox, specs.nextSibling);
      revealArea(areaBox);
    }

    // ── Сравнение с другими квартирами дома. Асинхронное: один запрос. ──
    buildVs().then((vs) => {
      if (!vs || !specs || !specs.parentNode) return;
      specs.parentNode.insertBefore(vs, specs);
      revealScale(vs);
    }).catch(() => { /* сеть отказала — блока просто нет, страница цела */ });
  }

  /** Кнопки карточки сделки. Сердечко и «поделиться» ПЕРЕИСПОЛЬЗУЮТ рабочие кнопки
      правой колонки — второго хранилища избранного не заводим. */
  function bindDeal() {
    const book = $('fcrBook');
    if (book) {
      book.addEventListener('click', () => {
        focusBookingForm();
        // Подсветка формы, до которой доехали: без неё кнопка «Забронировать»
        // в карточке сделки выглядит так, будто ничего не сделала — форма стоит
        // внизу правой колонки и на компьютере попадает в тот же экран.
        const form = $('flatBookingForm');
        if (!form) return;
        const card = form.closest('.flat-aside-form-card') || form;
        card.classList.add('fcr-hi');
        setTimeout(() => card.classList.remove('fcr-hi'), 2200);
      });
    }

    const fav = $('fcrFav');
    const railFav = $('flatRailFav');
    if (fav && railFav) {
      if (railFav.classList.contains('is-active')) {
        fav.classList.add('is-active');
        const i = fav.querySelector('i');
        if (i) { i.classList.remove('far'); i.classList.add('fas'); }
      }
      fav.addEventListener('click', () => {
        railFav.click();
        const on = railFav.classList.contains('is-active');
        fav.classList.toggle('is-active', on);
        const i = fav.querySelector('i');
        if (i) { i.classList.toggle('fas', on); i.classList.toggle('far', !on); }
      });
    }
    const share = $('fcrShare');
    const railShare = $('flatRailShare');
    if (share && railShare) share.addEventListener('click', () => railShare.click());
  }

  // ═══ BOTTOM BAR (mobile + desktop scroll) ═══
  function renderBottomBar() {
    const bar = $('flatBottomBar');
    const el = $('flatBottomPrice');
    if (el) el.textContent = fmtFull(FLAT.price);

    const bookBtn = $('flatBottomBook');
    if (bookBtn) {
      bookBtn.addEventListener('click', () => {
        const form = $('flatBookingForm');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Desktop: панель появляется, когда КАРТОЧКА СДЕЛКИ уходит из вида.
    // ⛔ Раньше наблюдали за #flatInfo — но он теперь спрятан (цена переехала в
    //    карточку сделки справа), а у скрытого элемента пересечения не бывает
    //    НИКОГДА: наблюдатель молча сообщал бы «панель нужна всегда». На телефоне
    //    это ровно то, что надо (так у ДомКлик), на компьютере — нет.
    //    Запасной путь на #flatInfo оставлен на случай, если карточка не собралась.
    //
    // ⛔ ТЕЛЕФОН — ПО ПРОКРУТКЕ (yandex-mobile 1.2, вариант А, решение владельца 18.09.2026).
    //    Раньше панель на телефоне стояла с первого экрана («так у ДомКлик»): замер
    //    320×568 — шапка 10,6 % + панель 12,2 % + планка cookie 8,6 % + кружки =
    //    35 % экрана под плавающими панелями, а мобильный робот Яндекса смотрит
    //    ровно этот первый экран. Теперь на телефоне панель выезжает, когда кнопка
    //    «Забронировать» карточки сделки (#fcrBook) УШЛА ВВЕРХ за экран: пока она
    //    видна или ещё впереди — то же действие рядом. Прячет CSS через
    //    `visibility` (css/flat.css): вне Tab-порядка и скринридера, макет не
    //    прыгает (панель fixed). Кнопки нет или она скрыта — панель видна всегда.
    //    Компьютер — прежнее правило без изменений.
    if (bar) {
      const priceBlock = $('fcrDeal') || $('flatInfo');
      const phoneAnchor = $('fcrBook') || priceBlock;
      const phone = window.matchMedia ? window.matchMedia('(max-width: 968px)') : null;
      let obs = null;
      if (priceBlock && 'IntersectionObserver' in window) {
        obs = new IntersectionObserver(([entry]) => {
          if (phone && phone.matches) return;
          bar.classList.toggle('flat-bottom-visible', !entry.isIntersecting);
        }, { threshold: 0 });
        obs.observe(priceBlock);
      }
      if (phone && phoneAnchor && 'IntersectionObserver' in window) {
        // Высота панели — для сдвига планки cookie через `translate` (css/flat.css):
        // смена `bottom` у fixed-элемента — сдвиг макета, его считает CLS (VERIFY-1.2b).
        // Пересчёт при смене размера (VERIFY-1.2b, P2-6; см. такой же кусок в public/js/jk.js).
        let lastH = '';
        const setH = () => {
          const h = bar.offsetHeight;
          if (!h) return;                     // панель не показана на этой ширине — запасное значение CSS
          if (h + 'px' !== lastH) {
            lastH = h + 'px';
            document.documentElement.style.setProperty('--flat-bb-h', lastH);
          }
        };
        setH();
        let hQueued = false;
        const queueH = () => {
          if (hQueued) return;
          hQueued = true;
          (window.requestAnimationFrame || setTimeout)(() => { hQueued = false; setH(); });
        };
        window.addEventListener('resize', queueH);
        if (typeof ResizeObserver === 'function') new ResizeObserver(queueH).observe(bar);
        // Панель нужна, когда кнопка ушла ВВЕРХ за экран или скрыта стилями.
        const syncPhone = () => {
          if (!phone.matches) return;
          const r = phoneAnchor.getBoundingClientRect();
          bar.classList.toggle('flat-bottom-visible', r.height === 0 || r.bottom <= 0);
        };
        // Первое положение — сразу и без анимации (см. такой же кусок в public/js/jk.js).
        syncPhone();
        bar.classList.add('flat-bb-reveal');
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(() => window.requestAnimationFrame(() => bar.classList.add('flat-bb-anim')));
        }
        const obsPhone = new IntersectionObserver(syncPhone, { threshold: 0 });
        obsPhone.observe(phoneAnchor);
        // ⛔ Прыжок из «выше экрана» сразу в «ниже» наблюдатель не замечает (признак
        //    пересечения не меняется) — сверка по прокрутке, не чаще раза в кадр (VERIFY-1.2b, P2-1).
        let queued = false;
        window.addEventListener('scroll', () => {
          if (queued) return;
          queued = true;
          (window.requestAnimationFrame || setTimeout)(() => { queued = false; syncPhone(); });
        }, { passive: true });
        // Смена ширины (поворот, окно) — пересчитать по актуальному правилу.
        const resync = () => {
          if (obs) { obs.unobserve(priceBlock); obs.observe(priceBlock); }
          obsPhone.unobserve(phoneAnchor); obsPhone.observe(phoneAnchor);
        };
        if (phone.addEventListener) phone.addEventListener('change', resync);
      }
    }
  }

  // ═══ BACK BAR (ВАЖНО-5) ═══
  function renderBackBar() {
    const el = $('flatBackBar');
    const link = $('flatBackLink');
    if (!el || !link) return;

    // Показать если пришли из каталога
    if (document.referrer && document.referrer.includes('flats.php')) {
      el.style.display = '';
      link.href = document.referrer;
    }
  }

  // ═══ [D1] ИСТОРИЯ ЦЕН (Sparkline) ═══
  async function renderPriceHistory() {
    const el = $('flatPriceHistory');
    if (!el || !FLAT.building_id) return;

    try {
      const res = await fetch(API + '?action=price_history&building_id=' + FLAT.building_id);
      const data = await res.json();
      if (!data.ok || !data.points || data.points.length < 2) {
        el.style.display = 'none';
        return;
      }

      const points = data.points;
      const prices = points.map(p => p.price_from || p.price_to || 0).filter(p => p > 0);
      if (prices.length < 2) { el.style.display = 'none'; return; }

      // SVG sparkline
      const W = 300, H = 80, pad = 4;
      const minP = Math.min(...prices);
      const maxP = Math.max(...prices);
      const range = maxP - minP || 1;
      const step = (W - 2 * pad) / (prices.length - 1);

      const pathPoints = prices.map((p, i) => {
        const x = pad + i * step;
        const y = H - pad - ((p - minP) / range) * (H - 2 * pad);
        return (i === 0 ? 'M' : 'L') + x.toFixed(1) + ',' + y.toFixed(1);
      }).join(' ');

      // Тренд: сравниваем последнюю и первую цену
      const trend = prices[prices.length - 1] - prices[0];
      const trendColor = trend > 0 ? 'var(--error)' : trend < 0 ? 'var(--success)' : 'var(--text-muted)';
      const trendIcon = trend > 0 ? 'fa-arrow-up' : trend < 0 ? 'fa-arrow-down' : 'fa-minus';
      const trendPct = ((trend / prices[0]) * 100).toFixed(1);

      el.style.display = '';
      el.innerHTML =
        '<h2 class="flat-section-title">Динамика цен ЖК</h2>'
      + '<div class="flat-sparkline-wrap">'
      + '  <svg class="flat-sparkline" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none">'
      + '    <path d="' + pathPoints + '" fill="none" stroke="' + trendColor + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '  </svg>'
      + '  <div class="flat-sparkline-info">'
      + '    <span class="flat-sparkline-range">'
      + '      ' + esc(fmt(minP)) + ' — ' + esc(fmt(maxP))
      + '    </span>'
      + '    <span class="flat-sparkline-trend" style="color:' + trendColor + '">'
      + '      <i class="fa-solid ' + trendIcon + '"></i> '
      + esc(String(Math.abs(parseFloat(trendPct)))) + '%'
      + '    </span>'
      + '  </div>'
      + '</div>';
    } catch {
      if (el) el.style.display = 'none';
    }
  }

  // ═══ ФОКУС ФОРМЫ БРОНИ (реюз: ?book=1 из оверлея каталога + плашка «Забронировать»
  //     справа от цены) ═══
  // Плавный скролл к #flatBookingForm + фокус в поле имени. Guard: нет формы/поля —
  // тихий выход. Без inline-handler'ов (CSP) — вызывается из addEventListener / book-param.
  function focusBookingForm() {
    const form = $('flatBookingForm');
    if (!form) return;
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const nameInput = form.querySelector('input[name=name]');
    if (nameInput) nameInput.focus({ preventScroll: true });
  }
  // ?book=1 — переход по кнопке «Забронировать» из оверлея квартиры (flat-overlay.js).
  function wantsBooking(search) {
    try { return new URLSearchParams(search || '').get('book') === '1'; }
    catch (_e) { return false; }
  }
  // Экспорт для behavioral-тестов (паттерн window.BroniFlatOverlay).
  window.BroniFlatBooking = { focusBookingForm: focusBookingForm, wantsBooking: wantsBooking };

  // Плашка «Забронировать» у цены (#flatPriceBook, renderInfo) → модалка брони (владелец
  // 2026-07-17). Общий модуль booking-modal.js (та же модалка, что с панели квартиры).
  // Fallback: если booking-modal.js не догрузился — старое поведение (скролл к aside-форме,
  // она на странице сохранена). reserved → модалка сама даёт заголовок «Узнать о похожих».
  const priceBookBtn = $('flatPriceBook');
  if (priceBookBtn) priceBookBtn.addEventListener('click', () => {
    if (typeof window.openBookingModal === 'function') {
      window.openBookingModal({
        flat_id: FLAT.id,
        building_id: FLAT.building_id,
        building_name: FLAT.building_name,
        rooms: FLAT.rooms,
        area: FLAT.area,
        reserved: String(FLAT.status || '') === 'reserved',
        source: 'flat_booking',
        context_label: 'карточка квартиры (плашка у цены)',
      });
    } else {
      focusBookingForm();
    }
  });

  // ?book=1 → автофокус формы после первичной раскладки (rAF, чтобы hero/картинки
  // уже встали в поток и smooth-scroll попал в верную позицию).
  if (wantsBooking(location.search)) {
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(focusBookingForm);
    else focusBookingForm();
  }

  // ═══ BOOKING FORM ═══
  const bookForm = $('flatBookingForm');
  if (bookForm) {
    bookForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      // lead-delivery 5.2 (152-ФЗ): без согласия submit блокируется (без фикции).
      // hotfix 2026-07-16: единообразная подсказка .consent-hint вместо alert; alert
      // остаётся fallback'ом если shared.js-хелпер по какой-то причине недоступен.
      const bookConsent = $('flatBookConsent');
      if (bookConsent && !bookConsent.checked) {
        if (typeof window.showConsentHint === 'function') window.showConsentHint(bookConsent);
        else alert('Поставьте галочку согласия на обработку персональных данных');
        return;
      }
      const fd = new FormData(bookForm);
      const body = {
        name: fd.get('name'),
        phone: fd.get('phone'),
        _hp: fd.get('_hp'),
        flat_id: FLAT.id,
        building_id: FLAT.building_id,
        building_name: FLAT.building_name,
        type: 'booking',
        // lead-delivery 3.1.3b: явный код источника — бронь квартиры
        // (бэкенд выбирает метку по type, source дублирует для читаемости).
        source: 'flat_booking',
      };
      // consent_main шлём ТОЛЬКО когда юзер сам отметил чекбокс (не хардкод).
      if (bookConsent && bookConsent.checked) body.consent_main = '1';

      const btn = bookForm.querySelector('button[type=submit]');
      if (btn) { btn.disabled = true; btn.textContent = 'Отправка...'; }

      try {
        const res = await fetch('/map_api.php?action=apply', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (data.ok) {
          // Метрика: цель «Бронирование квартиры» (exact booking_form_submit).
          // Без неё Директ не видит реальные конверсии брони с карточки квартиры.
          if (typeof ymGoal === 'function') ymGoal('booking_form_submit');
          bookForm.innerHTML = '<div class="flat-form-success"><i class="fa-solid fa-check-circle"></i> Заявка отправлена! Перезвоним за 5 минут.</div>';
        } else {
          if (btn) { btn.disabled = false; btn.textContent = 'Отправить заявку'; }
          alert(data.error || 'Ошибка отправки');
        }
      } catch {
        if (btn) { btn.disabled = false; btn.textContent = 'Отправить заявку'; }
        alert('Ошибка сети');
      }
    });
  }

  // ═══ VIEWING FORM удалена (jk-redesign 6.1j) ═══
  // Решение владельца 04.07: одна форма заявки на flat.php («Забронировать» в rail).
  // Отдельная «Записаться на просмотр» убрана как дубль-CTA — осознанное удаление
  // (разметка + обработчик submit + тесты актуализированы).

  // ═══ UTILS ═══
  function roomsLabel(r) {
    r = parseInt(r, 10);
    if (r === 0) return 'Студия';
    return r + '-комн.';
  }
})();
